var custom = {
  mobileBreakPoint: 768,
  currentVariant: {},
  navItems: {},
  hoverState: {},
  currNostoPage: 0,
  nostoActive: false,
  maxSlideshows: 4,
  sideCartRecLoaded: false,
  paginationCt: 48,
  numberOfNostoCalls: 0,
  TIMEOUT_DELAY_MS: 500,
  MAX_NOSTO_RETRIES: 4,
  isSearchPage: window.location.href.indexOf("/search") != -1,
  isCategoryPage: window.location.href.indexOf("/collections") != -1,
  isProductPage: window.location.href.indexOf("/products") != -1,
  isCartPage: window.location.href.indexOf("/cart") != -1,
  isHomePage: window.location.href.indexOf("/") == -1,
  pageSet: false,
  filtersArray: [],
  storedContentViews: [],
  currCollectionId: '',
  filtersChecked: false,
  force_default_accounts: [],
  loadProducts: true,
  currAccountId: '',
  filters: {
    collectionId: "",
    pageNum: 0,
    sort: "",
    filter: null,
    filterValid: null,
  },
  isMobile: function () {
    return window.innerWidth <= this.mobileBreakPoint;
  },
  isMobileBrowser: function () {
    var hasTouchScreen = false;
    var UA = navigator.userAgent;
    hasTouchScreen =
      /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
      /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);

    if (hasTouchScreen) {
      return true;
    }
    return false;
  },

  productSizeHover: function (product_id, sender) {
    if (this.isMobileBrowser()) {
      let productCard = sender.parentNode?.parentNode;
      let quickView = productCard?.querySelector("quick-view");
      if (!quickView) {
        productCard = sender.parentNode?.parentNode?.parentNode;
        quickView = productCard?.querySelector("quick-view");
      }
      if (quickView) {
        quickView.click();
      }
    } else if (!this.hoverState[product_id]) {
      this.hoverState = {};
      this.hoverState[product_id] = true;
      // this.hideAllSizeHovers();
      let containerId = "size_container_" + product_id;
      let containerElem = document.getElementById(containerId);
      if (containerElem) {
        containerElem.style.display = "block";
      }
      let optionElem = document.getElementById(`optionValues_${product_id}`);
      if (optionElem) {
        let optionValues = optionElem.value;
        custom.createButtonFilters(optionValues, product_id);
      }
    }
  },

  hideAllSizeHovers: function () {
    this.hoverState = {};
    let sizeContainers = document.querySelectorAll(".size-container");
    if (sizeContainers && sizeContainers.length > 0) {
      for (i = 0; i < sizeContainers.length; i++) {
        let container = sizeContainers[i];

        if (container) {
          container.style.display = "none";
        }
      }
    }
  },
  updateProductCard: function (
    elem,
    productId,
    handle,
    sib_id
  ) {
    let productCard = elem.closest('product-card');

    if (productCard) {
      var fromGallery = true;
      custom.getPdpItem(handle, false, productCard, true, productId, false, false, fromGallery);
    }
  },
  parseUrl: function (handle, small) {
    let feedType = "-regular";
    if (small) {
      feedType = "-small";
    }
    let productUrl = `/pages/product-card-api/${handle}`;
    if (theme.settings.locale != "" && theme.settings.locale != custom.default_lang) {
      custom.updateLocale();
      productUrl = `/${theme.settings.locale}/pages/product-card-api/${handle}`;
    }
    return productUrl;
  },
  updateCartRecommendations: function (locale, last_product, placementId, numberOfProducts) {

    let cartRecommendations = document.getElementById('shopify-section-side-cart');
    if (cartRecommendations) {
      custom.storeCartRecVariables(placementId, last_product, numberOfProducts, locale);
    }
  },
  storeCartRecVariables: function (placementId, last_product, numberOfProducts, locale) {
    custom.placementId = placementId;
    custom.last_product = last_product;
    custom.numberOfProducts = numberOfProducts;
    custom.locale = locale;
  },
  launchCartRecommendations: function () {
    if (!custom.sideCartRecLoaded) {
      let placementId = custom.placementId;
      let last_product = custom.last_product;
      let numberOfProducts = custom.numberOfProducts;
      let locale = custom.locale;
      if (placementId && numberOfProducts && locale) {
        // Only mark as loaded once we have valid config — a premature call
        // (before updateCartRecommendations runs) must not permanently block
        // future launches.
        custom.sideCartRecLoaded = true;
        custom.handleCartRecDots(numberOfProducts);
        custom.callNostoProducts(false, placementId, last_product, 'side-cart', numberOfProducts, locale);
        return;
      }
    }
  },
  addSizeToCart: function (variant_id, product_id, anchor) {
    loopClassDisplay(".loading-overlay", "flex");

    // Immediately open cart drawer in loading state
    var cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      // Cache section ID before the drawer gets moved to document.body on open.
      // Always overwrite: the liquid-rendered attribute can hold the bare
      // "cart-drawer" file name, and fetching that via the Section Rendering
      // API returns a static render with schema DEFAULTS instead of the saved
      // settings. The wrapper id ("sections--123__cart-drawer") is the source
      // of truth.
      var sectionWrapper = cartDrawer.closest('[id^="shopify-section-"]');
      if (sectionWrapper) {
        cartDrawer.setAttribute('data-section-id', sectionWrapper.id.replace('shopify-section-', ''));
      }
      // Add loading overlay if not already present
      if (!cartDrawer.querySelector('.cart-drawer__loading')) {
        var loadingText = cartDrawer.getAttribute('data-loading-text') || 'Updating your cart...';
        var overlay = document.createElement('div');
        overlay.className = 'cart-drawer__loading';
        overlay.innerHTML = '<div class="cart-drawer__loading-spinner"></div><span class="cart-drawer__loading-text">' + loadingText + '</span>';
        cartDrawer.appendChild(overlay);
      }
      cartDrawer.style.display = '';
      cartDrawer.classList.add("is-loading");
      cartDrawer.setAttribute("open", "");
    }

    let slotId = "";
    let salesTypeValue = "";
    let priceData = null;
    if (anchor) {
      let productCard = anchor.closest('product-card');
      slotId = productCard.getAttribute("nosto-slot-id");
      handle = productCard.getAttribute('handle');
      if (productCard.getAttribute('sales-type-value')) {
        salesTypeValue = productCard.getAttribute('sales-type-value');
      }
      // Compare-at pricing: read regular price, discount, percent from product card
      let compareAtAttr = productCard.getAttribute('data-b2b-prices');
      if (compareAtAttr) {
        try {
          let compareAtPrices = JSON.parse(compareAtAttr);
          if (compareAtPrices[variant_id]) {
            priceData = compareAtPrices[variant_id];
          }
        } catch (e) {}
      }
    }
    let formData = {
      items: [
        {
          id: variant_id,
          product_id: product_id
        },
      ],
    };

    let properties = {};
    if (salesTypeValue) {
      properties._saleType = salesTypeValue;
    }
    if (priceData) {
      let t = (theme && theme.settings && theme.settings.translations) || {};
      properties[t.regular_price || "Regular Price"] = priceData.cap;
      properties[t.discount_amount || "Discount Amount"] = priceData.disc;
      properties[t.discount_percent || "Discount %"] = priceData.pct;
    }
    if (Object.keys(properties).length > 0) {
      formData.items[0].properties = properties;
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        // GRIT-5704: cart/add.js returns 422 for sold-out variants — treat it
        // as an error instead of proceeding to render an empty cart drawer.
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((cart) => {
        if (slotId) {
          custom.trackNostoRecommendationsCartAdd(product_id, slotId);
        } else if (anchor) {
          let productsContainer = anchor.closest('.collection__main');
          let searchContainer = anchor.closest('predictive-search');
          if (productsContainer) {
            isCollectionItem = true;
            let url = `/products/${handle}?variant=${variant_id}`;
            custom.trackNostoCartAdd(product_id, url);
          } else if (searchContainer) {
            let url = `/products/${handle}?variant=${variant_id}`;
            custom.trackNostoCartAdd(product_id, url, true);
          }

        }

        fetchCartItems();
      })
      .catch((error) => {
        console.error("Error:", error);
        // GRIT-5704: the drawer was opened in a loading state before the add
        // request — close it again so a failed add doesn't leave an empty
        // cart drawer open.
        loopClassDisplay(".loading-overlay", "none");
        var cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.classList.remove("is-loading");
          var loadingOverlay = cartDrawer.querySelector(".cart-drawer__loading");
          if (loadingOverlay) {
            loadingOverlay.remove();
          }
          cartDrawer.removeAttribute("open");
        }
      });
    return false;
  },
  fetchCartForTracking: function () {
    getCartItems().then((cart) => {
      let cartItems = cart.items;
      cartItems = cartItems.map((item) => {
        return {
          name: item.title,
          price_currency_code: Shopify.currency.active,
          product_id: String(item.product_id),
          quantity: item.quantity,
          sku_id: item.sku,
          unit_price: item.price
        };
      });
    });

  },
  addSelectedVariantToCart: function (product_id, button) {
    // GRIT-5704: sold-out products have no available variant to add — do
    // nothing instead of posting an unavailable variant and opening an
    // empty cart drawer.
    if (button.getAttribute('data-product-available') === 'false') {
      return false;
    }
    let variant_id = button.getAttribute('data-default-variant-id');
    let variantMap = {};
    try {
      variantMap = JSON.parse(button.getAttribute('data-variant-map') || '{}');
    } catch (e) {
      variantMap = {};
    }
    let productCard = button.closest('product-card');
    if (productCard) {
      let checkedSwatches = productCard.querySelectorAll('.product-card__swatches input[type="radio"]:checked');
      if (checkedSwatches.length > 0) {
        let selectedValues = Array.from(checkedSwatches).map((input) => input.value);
        let key = selectedValues.join(' / ');
        if (variantMap[key]) {
          variant_id = variantMap[key];
        } else {
          let matchKey = Object.keys(variantMap).find((k) => {
            let parts = k.split(' / ');
            return selectedValues.every((v) => parts.includes(v));
          });
          if (matchKey) {
            variant_id = variantMap[matchKey];
          }
        }
      }
    }
    if (variant_id) {
      custom.addSizeToCart(variant_id, product_id, button);
    }
    return false;
  },
  addSingleSizeToCart: function (product_id) {
    loopClassDisplay(".loading-overlay", "flex");

    let formData = {
      items: [
        {
          id: product_id,
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })

    return false;
  },
  closeSizeOverlay: function () {
    // this.hideAllSizeHovers();
  },
  toggleDiscount: function () {
    let discountDiv = document.getElementById("PopupDiscount");
    let disountOverlay = document.getElementById("PopupDiscount");
    if (discountDiv.style.zIndex == -1) {
      discountDiv.style.zIndex = 100;
      discountDiv.style.visibility = "";
      disountOverlay.style.display = 'block';
    } else {
      disountOverlay.style.zIndex = '-1';
      disountOverlay.style.display = 'none';

    }
  },
  updateLocale: function () {
    if (theme && theme.settings) {
      //Fetch the locale from the URL. Search through slashes to make sure its either 2 characters or has a dash
      let urlSegments = location.href.split("/");
      let segmentFound = false;
      for (let segment of urlSegments) {
        if (segment.length === 2 || (segment.includes("-") && segment.length == 5)) {
          theme.settings.locale = segment;
          segmentFound = true;
          break; // Exit the loop once a valid segment is found
        }
      }
      if (!segmentFound) {
        theme.settings.locale = ""; // Reset to empty if no valid segment found
      }
    }
  },
  hasDiscountCookie: function () {
    var cookieValue = custom.getCookie('discount_code');
    if (cookieValue) {
      localStorage.setItem('discount_code', cookieValue);
      return true;
    }
    if (localStorage.getItem('discount_code')) {
      return true;
    }
    return false;
  },
  validateSalePrice: function (productId, quickBuyElem, handle) {
    // GRIT-4652: Delegated to centralized PricingService
    custom.currentVariant.product_id = productId;
    if (typeof PricingService !== 'undefined') {
      PricingService.onVariantChange(productId, quickBuyElem, handle);
    }
  },
  checkForEmptyPrice: function () {
    // GRIT-4652: Delegated to centralized PricingService
    if (typeof PricingService !== 'undefined') {
      PricingService.fillEmptyPrices();
    }
  },
  removeExtraPrice: function (priceList) {
    // GRIT-4652: Delegated to centralized PricingService
    if (typeof PricingService !== 'undefined') {
      var compareAt = priceList.querySelector('compare-at-price');
      var salePrice = priceList.querySelector('sale-price');
      PricingService.cleanPriceElement(compareAt);
      PricingService.cleanPriceElement(salePrice);
    }
  },
  handlePriceList: function (priceList) {
    // GRIT-4652: Delegated to centralized PricingService
    if (typeof PricingService !== 'undefined') {
      PricingService.applyPricing(priceList);
    }
  },
  toggleSizeChart: function (size_link) {
    if (size_link) {
      let variants = [];
      if (size_link.dataset.productVariants) {
        variants = JSON.parse(size_link.dataset.productVariants);
      }
      // Extract product data from data attributes
      const productData = {
        id: size_link.dataset.productId,
        title: size_link.dataset.productTitle,
        variants: variants,
        category: size_link.dataset.productType,
        brand: size_link.dataset.productVendor,
      };

      //Load Kiwi Sizing for the selected product
      ks.loadSizing({
        productData: productData,
      });

    }

    // Find the size chart modal scoped to the current product context.
    // First check if the clicked element is inside a size chart modal (closing case),
    // then look within the product context (opening case).
    let sizeChartModal = null;
    if (size_link && size_link.closest) {
      sizeChartModal = size_link.closest('#toggleSizeChart');
      if (!sizeChartModal) {
        const productContext = size_link.closest('.product-info') || size_link.closest('.quick-buy-modal__content');
        if (productContext) {
          sizeChartModal = productContext.querySelector('#toggleSizeChart');
        }
      }
    }
    if (!sizeChartModal) {
      sizeChartModal = document.getElementById("toggleSizeChart");
    }

    // Pause/unpause the quick-buy modal's FocusTrap so it doesn't interpret
    // size chart interactions as outside clicks that should close the quick-buy
    var quickBuyModal = document.querySelector('quick-buy-modal[open]');

    if (sizeChartModal.style.zIndex == -1) {
      // Move modal to document.body so it escapes the quick-buy modal stacking context
      if (sizeChartModal.parentElement !== document.body) {
        sizeChartModal._originalParent = sizeChartModal.parentElement;
        document.body.appendChild(sizeChartModal);
      }
      if (quickBuyModal && quickBuyModal.focusTrap) {
        quickBuyModal.focusTrap.pause();
      }
      sizeChartModal.style.zIndex = 10000;
      sizeChartModal.style.visibility = "";
      sizeChartModal.style.display = 'block';
    } else {
      sizeChartModal.style.zIndex = '-1';
      sizeChartModal.style.display = 'none';
      if (quickBuyModal && quickBuyModal.focusTrap) {
        quickBuyModal.focusTrap.unpause();
      }
    }
  },

  createNavigation: function (menu_key, openMenuTitle, currentPage) {
    // GRIT-5604: After B2C→B2B rep signup, the nav cache still holds the B2C menu
    // because the cache key includes customer_id (unchanged) but not tags/role.
    // Bust all nav cache keys on the post-signup welcome page so the B2B menu loads fresh.
    if (window.location.pathname.indexOf('/pages/newrep-welcome') !== -1 && !custom._navCacheBusted) {
      custom._navCacheBusted = true;
      let keysToRemove = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        let k = sessionStorage.key(i);
        if (k && k.startsWith('navigation')) {
          keysToRemove.push(k);
        }
      }
      keysToRemove.forEach(function(k) { sessionStorage.removeItem(k); });
    }
    if (custom.getAttribute('navigation_test')) {
      menu_key = custom.getAttribute('navigation_test');
    }
    let setDateTimestamp = custom.getSetDateTimestamp();
    if (setDateTimestamp) {
      menu_key += '|' + setDateTimestamp;
    }
    custom.updateLocale();
    const countryKey = theme.settings.country ? theme.settings.country : 'default';
    const localeKey = theme.settings.locale ? theme.settings.locale : custom.default_lang;
    const customerIdKey = theme.settings.customer_id ? theme.settings.customer_id : 'guest';
    let storageKey = "navigation_" + menu_key + "_" + localeKey + "_" + countryKey + "_" + customerIdKey;
    let currentMenuStorage = sessionStorage.getItem(storageKey);

    //Check if the menu has been stored for over 5 minutes, if so then delete the storage and allow it to resave
    let now = Date.now();
    let timeKey = "navigation_time_" + menu_key;
    let before = sessionStorage.getItem(timeKey);
    if (before) {
      let diff = now - before;
      if (diff > 300000) {
        sessionStorage.removeItem(storageKey);
        sessionStorage.removeItem(timeKey);
      }
    }

    // Pass any cookies that are set for navigation personalization
    let sendCookies = "";
    let cookieStorageSet = false;
    let navigationCookies = theme.settings.navigation_cookies;
    if (navigationCookies && navigationCookies.indexOf(",") != -1) {
      const cookieStorage = localStorage.getItem("cookie-storage");
      navigationCookiesArr = navigationCookies.split(",");
      navigationCookiesArr.forEach((cookieName, index) => {
        if (custom.getCookie(cookieName) || localStorage.getItem(cookieName)) {
          if (!localStorage.getItem(cookieName)) {
            cookieStorageSet = true; //If we are just setting new cookies then we want to refetch the nav
          }
          localStorage.setItem(cookieName, 1);
          sendCookies += cookieName;
          if (index < navigationCookiesArr.length - 1) {
            sendCookies += ",";
          }
        }
      });
      if (cookieStorage !== theme.settings.navigation_cookies) {
        cookieStorageSet = true; //If we are just setting new cookies then we want to refetch the nav
        localStorage.setItem("cookie-storage", theme.settings.navigation_cookies);
      }
    }

    if (currentMenuStorage && !setDateTimestamp && !cookieStorageSet && !Shopify.designMode) {
      let data = JSON.parse(currentMenuStorage);
      this.createDesktopNav(data, openMenuTitle, currentPage);
      this.createMobileNav(data);
    } else {
      let fetchUrl = custom.parsePageUrl("metaobject-api/nosto_navigation*" + menu_key + "*" + sendCookies);
      fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text(); // Get as text first
        })
        .then((text) => {
          // Clean the JSON string by removing/replacing control characters
          const cleanedText = text.replace(/[\x00-\x1F\x7F]/g, ''); // Remove control chars
          // Or more targeted: text.replace(/[\n\r\t]/g, ''); // Remove newlines, returns, tabs
          return JSON.parse(cleanedText);
        })
        .then((result) => {
          if (custom.getAttribute("debugnav")) {
            console.log("nav api result:", result);
          }
          if (result.nosto_navigation && result.nosto_navigation[0]) {
            let data = result.nosto_navigation[0].data;
            if (data && data.nav_categories) {
              sessionStorage.setItem(storageKey, JSON.stringify(data));
              sessionStorage.setItem("navigation_time_" + menu_key, now);
              this.createDesktopNav(data, openMenuTitle, currentPage);
              this.createMobileNav(data);
            }
          }
        })
        .catch((error) => {
          console.error("Fetch/Parse failed:", error);
        });
    }
  },
  checkForLocale: function (url) {
    let locale = '';
    if (theme.settings.locale && theme.settings.locale != custom.default_lang) {
      custom.updateLocale();
      locale = '/' + theme.settings.locale
    }
    //Check if the first character of url is a slash, if not then add the locale before the url
    if (url.charAt(0) !== '/') {
      // If the URL does not start with a slash, remove any domain and make sure it starts with a slash
      // This is to ensure that the URL is relative
      // and does not include the domain name.
      url = '/' + url.replace(/^(https?:\/\/)?[^\/]+/, '');
    }
    return locale + url;
  },
  addDesktopListeners: function () {
    // Open mega menu on hover
    const detailsElements = document.querySelectorAll('details.nav-menu-item');
    if (detailsElements) {
      detailsElements.forEach((detailsElement) => {
        detailsElement.addEventListener('mouseenter', () => {
          detailsElements.forEach((element) => element.open = false);
          detailsElement.open = true;
        });
      });
    }

    // Close mega menu when mouse leaves the mega menu
    const megaMenus = document.querySelectorAll('.mega-menu');
    const secondaryNav = document.querySelector('.header__secondary-nav');
    const logo = document.querySelector('.header__logo');
    if (logo) { // Close mega menu when mouse leaves the logo
      logo.addEventListener('mouseenter', () => {
        detailsElements.forEach((element) => element.open = false);
      });
    }
    if (secondaryNav) {// Close mega menu when mouse leaves the secondary nav
      secondaryNav.addEventListener('mouseenter', () => {
        detailsElements.forEach((element) => element.open = false);
      });
    }
    if (megaMenus) {// Close mega menu when mouse leaves the mega menu
      megaMenus.forEach((megaMenu) => {
        megaMenu.addEventListener('mouseleave', () => {
          detailsElements.forEach((element) => element.open = false);
        });
      });
    }
    // Close vertical (non-mega) dropdown menus on mouseleave
    const verticalMenus = document.querySelectorAll('.header__dropdown-menu');
    if (verticalMenus) {
      verticalMenus.forEach((menu) => {
        var parentDetails = menu.closest('details.nav-menu-item');
        if (parentDetails) {
          menu.addEventListener('mouseleave', () => {
            parentDetails.open = false;
          });
        }
      });
    }
  },
  createButtonFilters: function (inputStr, product_id) {
    let from_hover = product_id && product_id != "";
    // Parse the input string to create a mapping of numbers to letters
    const items = inputStr.split(',').filter(Boolean); // Remove empty string at the end
    const numberToLettersMap = {};
    items.forEach(item => {

      let itemSplit = item.split("/");
      const number1 = itemSplit[0];
      const number2 = itemSplit[1];

      if (!numberToLettersMap[number1]) {
        numberToLettersMap[number1] = [];
      }

      // Only add the letter if it's not already in the array to avoid duplicates
      if (!numberToLettersMap[number1].includes(number2)) {
        numberToLettersMap[number1].push(number2);
      }
    });

    let numberButtonsContainer = document.getElementById('numberButtons');
    let letterButtonsContainer = document.getElementById('letterButtons');
    if (product_id) {
      numberButtonsContainer = document.querySelector(`.numberButtons-${product_id}`);
      letterButtonsContainer = document.querySelector(`.letterButtons-${product_id}`);
    }
    if (!numberButtonsContainer || !letterButtonsContainer) {
      return false;
    }
    // Clear existing buttons
    numberButtonsContainer.innerHTML = '';
    letterButtonsContainer.innerHTML = '';

    let currentSelectedNumber = null;
    let defaultNumberSet = false;

    // Function to handle button click and add 'active' class
    function handleButtonClick(button, container) {
      document.getElementById('numbers_disabled').checked = true;
      // Remove 'active' class from all buttons in the container
      let buttons = container.getElementsByClassName('variant-button');
      if (from_hover) {
        buttons = container.getElementsByClassName('hover-size');
      }
      for (let btn of buttons) {
        btn.classList.remove('active');
      }

      // Add 'active' class to the clicked button
      button.classList.add('active');
      let buttonSplit = button.id.split('_');
      let numberOfUnderscores = buttonSplit.length - 1;
      if (numberOfUnderscores == 1) {
        custom.showSelectSize();
      } else {
        custom.hideSelectSize();

        if (from_hover) {
          let num1 = buttonSplit[1];
          let num2 = buttonSplit[2];
          let variantElem = document.getElementById(`variant_${product_id}_${num1}_${num2}`);
          let variant_id = variantElem.value;
          let quantity = variantElem.getAttribute('quantity');
          if (quantity > 0) {
            custom.addSizeToCart(variant_id, product_id, button);
          }
        }
      }

    }

    // Function to update the letter buttons based on the selected number
    function updateLetterButtons(selectedNumber) {
      const availableLetters = numberToLettersMap[selectedNumber];

      // Clear the letter buttons container
      letterButtonsContainer.innerHTML = '';

      // Create and append letter buttons
      availableLetters.forEach(letter => {
        const button = document.createElement('button');
        button.className = 'variant-button';
        if (from_hover) {
          button.className = ' hover-size'
        }
        button.textContent = letter;
        button.id = 'btn_' + selectedNumber + '_' + letter;
        if (!from_hover) {
          document.querySelectorAll('.block-swatch').forEach((element) => {
            if (element.querySelector('span').textContent === (selectedNumber + '/' + letter) && element.classList.contains('is-disabled')) {
              button.classList.add('is-disabled');
            }
          });
        } else {
          let variantElem = document.getElementById(`variant_${product_id}_${selectedNumber}_${letter}`);
          let variantQuantity = variantElem.getAttribute('quantity');
          if (variantQuantity == 0) {
            button.classList.add('no-quantity');
          }
        }

        button.onclick = () => {
          let buyButtons = document.querySelector('buy-buttons');
          if (buyButtons) {
            buyButtons.querySelector('.addtocart').style.display = 'block';
          }
          handleButtonClick(button, letterButtonsContainer);
          if (currentSelectedNumber && !button.disabled) {
            custom.updateMainDropdown(currentSelectedNumber + '/' + letter);
          }
        };
        letterButtonsContainer.appendChild(button);
      });
    }


    // Create and append number buttons
    Object.keys(numberToLettersMap).forEach((number, indx) => {
      const button = document.createElement('button');
      button.className = 'variant-button';
      if (from_hover) {
        button.className = 'hover-size'
      }
      button.textContent = number;
      button.id = 'btn_' + number;
      if (from_hover) {
        let variantSingleElems = document.querySelectorAll(`.variant_${product_id}_${number}`);
        let hasItems = false;
        variantSingleElems.forEach((elem) => {
          let quantity = elem.getAttribute('quantity');
          if (quantity > 0) {
            hasItems = true;
          }
        });
        if (!hasItems) {
          button.classList.add('no-quantity');
        }
      }

      button.onclick = () => {
        let buyButtons = document.querySelector('buy-buttons');
        if (buyButtons) {
          if (buyButtons.querySelector('.klaviyo-bis-trigger')) {
            buyButtons.querySelector('.klaviyo-bis-trigger').style.display = 'none';
          }
          if (buyButtons.querySelector('.addtocart')) {
            buyButtons.querySelector('.addtocart').style.display = 'none';
          }
        }
        handleButtonClick(button, numberButtonsContainer);
        updateLetterButtons(number);
        currentSelectedNumber = number;
      };
      numberButtonsContainer.appendChild(button);
      if (indx == 0) {//open first number by default
        let timeoutnum = 1000;
        if (from_hover) {
          timeoutnum = 100;
        }
        setTimeout(() => {
          button.click();
          if (!from_hover) {
            custom.checkForDisabled(numberToLettersMap);
          }
        }, timeoutnum);
      }
    });

  },
  hideSelectSize: function () {
    let selectSizeElem = document.getElementById('select_size');
    if (selectSizeElem) {
      selectSizeElem.style.display = 'none';
    }
  },
  showSelectSize: function () {
    let formElem = document.querySelector('.shopify-product-form');
    if (formElem) {
      document.getElementById('select_size').style.display = 'block';
    }
  },
  checkForDisabled: function (numberToLettersMap) {
    let firstValidWaist = '';
    let firstValidInseam = '';
    let allDisabled = true;

    Object.keys(numberToLettersMap).forEach((number, indx) => {
      let hasEnabled = false;
      const availableLetters = numberToLettersMap[number];
      availableLetters.forEach(letter => {
        document.querySelectorAll('.block-swatch').forEach((element) => {
          if (element.querySelector('span').textContent === (number + '/' + letter)) {
            if (!element.classList.contains('is-disabled')) {
              hasEnabled = true;
              allDisabled = false;
              if (!firstValidWaist && !firstValidInseam) {
                firstValidWaist = number;
                firstValidInseam = letter;
              }
            }
          }
        });

      });
      if (!hasEnabled) {
        document.getElementById('btn_' + number).classList.add('is-disabled');
      }
    });
    if (allDisabled) {
      let buttonsElem = document.getElementById('letterButtons');
      if (buttonsElem) {
        let buttons = buttonsElem.querySelectorAll('button');
        if (buttons) {
          buttons[0].click();
        }
      }
    }
    else if (firstValidWaist && firstValidInseam) {
      document.getElementById('btn_' + firstValidWaist).click();
      document.getElementById('btn_' + firstValidWaist + '_' + firstValidInseam).click();
    } else {

    }

  },
  updateMainDropdown: function (value) {

    document.querySelectorAll('.sr-only').forEach((element) => {
      if (element.getAttribute('value') === value) {
        element.click();
      }
    });

  },
  removePlPrice: function (elem) {
    const plPriceElem = elem.querySelector('.pl-price');
    if (plPriceElem && custom.isProductPage) {
      plPriceElem.textContent = "";
    }
  },
  validatePlPrice: function (handle) {
    // GRIT-4652: Delegated to centralized PricingService
    if (typeof PricingService === 'undefined') return;

    // Clean open modals
    var modals = document.querySelectorAll('quick-buy-modal');
    Array.from(modals).filter(function(m) { return m.hasAttribute('open'); }).forEach(function(modal) {
      PricingService.applyWithinContainer(modal);
    });

    // GRIT-4652: Removed priceDiscountInvalid early return — the global variable gets
    // corrupted by recommended product cards (which set it to true), causing ALL prices
    // on the page to be cleared on variant change. PricingService.applyPricing handles
    // both sale and non-sale products correctly via data attributes on each price-list.

    // Find quick-buy element by handle
    var quickbuyElem = null;
    document.querySelectorAll('quick-buy-modal').forEach(function(qb) {
      if (qb.getAttribute('handle') && qb.getAttribute('handle').includes(handle)) {
        quickbuyElem = qb;
      }
    });

    if (quickbuyElem) {
      custom.currentVariant.product_id = quickbuyElem.getAttribute('product-id');
      PricingService.applyWithinContainer(quickbuyElem);
    }

    if (custom.isProductPage) {
      PricingService.applyAll();
    }

    var productIdElem = document.querySelector('.product-id');
    if (productIdElem) {
      custom.currentVariant.product_id = productIdElem.value;
    }
    PricingService.onVariantChange(custom.currentVariant.product_id, quickbuyElem, handle);
    PricingService.fillEmptyPrices();
  },
  updateSearchBox: function (searchTerm) {
    let mainSearchElem = document.getElementById("mainSearchContent");
    mainSearchElem.innerHTML = `
    <div class="predictive-search__results predictive-search__results--with-suggestions">
      <div class="predictive-search__resource-item" role="tabpanel" slot="content">
        <div id="keyword-results"></div>
      </div>
      <div class="predictive-search__resource-item">
        <div class="v-stack gap-8 sm:gap-12">
          <div class="predictive-search__products" id="search-results"></div>
        </div>
      </div>
    </div>`;
    if (searchTerm && searchTerm != "") {
      custom.filterNostoSearch(searchTerm)
    }
    else {
      console.log('no search term');
    }
  },
  createDesktopNav: function (json, openMenuTitle, currentPage) {
    custom.logIfNavigationIsEmpty(json);
    setTimeout(() => {
      custom.addDesktopListeners();
    }, 500);

    let navData = json["nav_categories"];
    if (navData.length > 0) {
      let navWrapper = document.getElementById("nosto-menu-desktop");
      let navButton = document.createElement("button");
      navButton.setAttribute("type", "button");
      navButton.setAttribute("aria-controls", "sidebar-menu");
      navButton.setAttribute("class", "md:hidden");
      navWrapper.appendChild(navButton);
      let openMenu = document.createElement("span");
      openMenu.setAttribute("class", "sr-only");
      openMenu.innerHTML = openMenuTitle;
      navButton.appendChild(openMenu);
      let menuIcon = document.createElement("svg");
      menuIcon.setAttribute("aria-hidden", "true");
      menuIcon.setAttribute("fill", "none");
      menuIcon.setAttribute("focusable", "false");
      menuIcon.setAttribute("width", "24");
      menuIcon.setAttribute("class", "header__nav-icon icon icon-hamburger");
      menuIcon.setAttribute("viewBox", "0 0 24 24");
      let iconPath = document.createElement("path");
      iconPath.setAttribute("d", "M1 19h22M1 12h22M1 5h22");
      iconPath.setAttribute("stroke", "currentColor");
      iconPath.setAttribute("stroke-width", 1.8);
      iconPath.setAttribute("stroke-linecap", "square");
      menuIcon.appendChild(iconPath);
      navButton.appendChild(menuIcon);
      let innerListItemAnchor = null;
      let firstLevelListElement = document.createElement("ul");
      navWrapper.appendChild(firstLevelListElement);
      firstLevelListElement.setAttribute("class", "contents unstyled-list md-max:hidden");
      navData.forEach((level1MenuData) => {
        let listItem = document.createElement("li");
        listItem.setAttribute("class", "header__primary-nav-item");
        listItem.setAttribute("data-title", level1MenuData.name);
        firstLevelListElement.appendChild(listItem);
        if (level1MenuData.categories && level1MenuData.categories.length == 0) {
          let anchor = document.createElement("a");
          if (level1MenuData.trigger_bulk_order == 'true') {
            anchor.setAttribute("href", "#");
            anchor.setAttribute("class", "block h6 nav-menu-item bulk-order-trigger");
          } else {
            anchor.setAttribute("href", custom.fetchLinkWithLocal(level1MenuData.url));
            anchor.setAttribute("class", "block h6 nav-menu-item");
          }
          if (level1MenuData.url == currentPage) {
            anchor.setAttribute("aria-current", "page");
          }
          anchor.innerHTML = level1MenuData.name;
          listItem.appendChild(anchor);
        } else {
          let details = document.createElement("details");
          details.setAttribute("is", "mega-menu-disclosure");
          details.setAttribute("class", "nav-menu-item header__menu-disclosure");
          details.setAttribute("follow-summary-link", "");
          details.setAttribute("trigger", "hover");
          listItem.appendChild(details);
          let summary = document.createElement("summary");
          let level1Url = custom.fetchLinkWithLocal(level1MenuData.url);
          summary.setAttribute("data-follow-link", level1Url);
          summary.setAttribute("class", "h6");
          let level1Style = "";
          if (level1MenuData.color) {
            level1Style = ` style="color:${level1MenuData.color}"`;
          }
          if (level1MenuData.url) {
            summary.innerHTML = `<a ${level1Style} href="${level1Url}">${level1MenuData.name}</a>`;
          } else {
            summary.innerHTML = level1MenuData.name;
          }
          details.appendChild(summary);
          let megaMenuDiv = document.createElement("div");
          details.appendChild(megaMenuDiv);
          megaMenuDiv.setAttribute("class", "mega-menu");
          if (level1MenuData.categories && level1MenuData.categories.length > 0) {
            let level2MenuList = document.createElement("ul");
            megaMenuDiv.appendChild(level2MenuList);
            level2MenuList.setAttribute("class", "mega-menu__linklist unstyled-list");
            if (level1MenuData.vertical_submenu == 'true') {
              // get the div parent and remove the class
              level2MenuList.parentElement.classList.remove('mega-menu');
              level2MenuList.setAttribute("class", "header__dropdown-menu header__dropdown-menu--restrictable unstyled-list");
            }
            level1MenuData.categories.forEach((level2MenuData) => {
              let level2MenuItem = document.createElement("li");
              level2MenuItem.setAttribute("class", "v-stack justify-items-start gap-5");
              if (level2MenuData.display_type == 'Mobile Only') {
                level2MenuItem.classList.add('mobile_only');
              }
              if (level2MenuData.display_type == 'Desktop Only') {
                level2MenuItem.classList.add('desktop_only');
              }
              level2MenuList.appendChild(level2MenuItem);
              let titleAnchor = document.createElement("a");
              if (level2MenuData.trigger_bulk_order == 'true') {
                titleAnchor.setAttribute("href", "#");
                titleAnchor.setAttribute("class", "h6 bulk-order-trigger");
              } else {
                titleAnchor.setAttribute("href", custom.fetchLinkWithLocal(level2MenuData.url));
                titleAnchor.setAttribute("class", "h6");
              }
              titleAnchor.innerHTML = level2MenuData.title;
              if (level2MenuData.title) {
                level2MenuItem.appendChild(titleAnchor);
              }
              if (level2MenuData.type == 'navigation_promos' && level2MenuData.promo_image) {
                let promoLink = custom.fetchLinkWithLocal(level2MenuData.promo_url);
                let promoDiv = `
                  <div class="mega-menu__promo" style="opacity: 1;">
                    <a href="${promoLink}" class="v-stack justify-items-center gap-4 sm:gap-5 group"><div class="overflow-hidden">
                        <img src="${level2MenuData.promo_image}" alt="" srcset="" width="1534" height="1752" loading="lazy" sizes="315px" class="zoom-image group-hover:zoom">
                      </div>
                      <div class="v-stack text-center gap-2.5">
                        <p class="h6">${level2MenuData.promo_title}</p>
                        <p class="smallcaps text-xs text-subdued">${level2MenuData.promo_subtitle}</p>
                      </div>
                    </a>
                  </div>
                  `
                megaMenuDiv.innerHTML += promoDiv;
              }
              else if (level2MenuData.type == 'navigation_links' && level2MenuData.items.length > 0) {
                let level3MenuList = document.createElement("ul");
                level2MenuItem.appendChild(level3MenuList);
                level3MenuList.setAttribute("class", "v-stack gap-2.5 unstyled-list");
                level2MenuData.items.forEach((level3MenuData) => {
                  let level3MenuItem = document.createElement("li");
                  level3MenuList.appendChild(level3MenuItem);
                  innerListItemAnchor = document.createElement("a");
                  if (level3MenuData.trigger_bulk_order == 'true') {
                    innerListItemAnchor.setAttribute("href", "#");
                    innerListItemAnchor.setAttribute("class", "link-faded bulk-order-trigger");
                  } else {
                    innerListItemAnchor.setAttribute("href", custom.fetchLinkWithLocal(level3MenuData.url));
                    innerListItemAnchor.setAttribute("class", "link-faded");
                  }
                  innerListItemAnchor.innerHTML = level3MenuData.name;
                  level3MenuItem.appendChild(innerListItemAnchor);
                  if (level3MenuData.display_type == 'Mobile Only') {
                    if (innerListItemAnchor) {
                      let liElem = innerListItemAnchor.parentNode;
                      if (liElem) {
                        liElem.classList.add('mobile_only');
                      }
                    }
                  }
                  if (level3MenuData.display_type == 'Desktop Only') {
                    if (innerListItemAnchor) {
                      let liElem = innerListItemAnchor.parentNode;
                      if (liElem) {
                        liElem.classList.add('desktop_only');
                      }
                    }
                  }
                });
              }
            });
          }
        }
      });
    }
  },
  fetchLinkWithLocal: function (url) {
    if (!url) return "#";
    if (url.startsWith("http://") || url.startsWith("https://")) {
      try {
        var parsed = new URL(url);
        if (parsed.hostname === window.location.hostname) {
          var localePrefix = window.Shopify.routes.root.slice(0, -1);
          if (localePrefix && !parsed.pathname.startsWith(localePrefix)) {
            parsed.pathname = localePrefix + parsed.pathname;
          }
          return parsed.toString();
        }
      } catch (e) {}
      return url;
    }
    return window.Shopify.routes.root.slice(0, -1) + url;
  },
  createLink: function (link, classValue) {
    if (!classValue) {
      classValue = "";
    }
    if (link.display_type == 'Mobile Only') {
      classValue += ' mobile_only';
    }
    if (link.display_type == 'Desktop Only') {
      classValue += ' desktop_only';
    }
    let linkColor = "";
    if (link.color) {
      linkColor = ` style="color:${link.color}"`;
    }

    let linkHref = custom.fetchLinkWithLocal(link.url);
    let bulkOrderClass = '';
    if (link.trigger_bulk_order == 'true') {
      linkHref = '#';
      bulkOrderClass = ' bulk-order-trigger';
    }
    let linkHTML = `
      <a${linkColor} class="${classValue}${bulkOrderClass}" href="${linkHref}" title="${link.name}" role="menuitem">${link.name} </a>
      `;
    return linkHTML;
  },
  createMobileNav: function (json) {
    custom.logIfNavigationIsEmpty(json);
    let mobileFooterElem = document.querySelector('.mobile_footer_menu');
    if (mobileFooterElem) {
      let footerLinks = json.mobile_footer_links;
      if (footerLinks) {
        footerLinks.forEach((link) => {
          let liElem = document.createElement('li');
          let linkElem = document.createElement('a');

          linkElem.setAttribute('href', custom.fetchLinkWithLocal(link.url));
          linkElem.setAttribute('class', 'mobile_footer_menu_link');
          linkElem.innerHTML = link.title;
          liElem.appendChild(linkElem);
          if (link.icon) {
            let iconElem = document.createElement('img');
            iconElem.setAttribute('src', link.icon);
            linkElem.appendChild(iconElem);
          }
          mobileFooterElem.appendChild(liElem);
        });
      }
    }
    let mobileDiv = document.querySelector(".nav-mobile");
    if (mobileDiv) {
      mobileDiv.innerHTML = "";
      let menuHTML = "";
      json.nav_categories.map((item, idx) => {
        let categories = item.categories_mobile;
        let style = "";
        if (item.color) {
          style = ` style="color:${item.color}"`;
        }
        if (!categories || categories.length == 0) {
          categories = item.categories;
        }
        if (categories && categories.length > 0) {
          menuHTML += `
          <li style="opacity: 1; transform: translateY(0px);">
            <button type="button" ${style} class="header-sidebar__linklist-button h6" aria-controls="${item.handle}" aria-expanded="true">${item.name}
            <svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-chevron-right  icon--direction-aware" viewBox="0 0 10 10">
                <path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"></path>
              </svg></button>
          </li>    
        `;
        } else {
          menuHTML += `
          <li style="opacity: 1; transform: translateY(0px);">${custom.createLink(item, 'header-sidebar__linklist-button h6')}</li>
        `;
        }
        if (categories && categories.length > 0) {
          let detailsHTML = document.querySelector(".nav-mobile-collapsed");
          let innerNavigation = "";
          categories.map((category) => {
            if (category.type == "navigation_promos") {
              let promoTitle = category.promo_title;
              let promoImage = category.promo_image;
              let promoSubTitle = category.promo_subtitle ? category.promo_subtitle : "";
              let promoLink = category.promo_url ? category.promo_url : "#";
              promoLink = custom.fetchLinkWithLocal(promoLink);
              if (promoTitle && promoImage) {
                innerNavigation += `
                <div class="header-sidebar__promo scroll-area bleed md:unbleed" style="opacity: 1;">
                  <a href="${promoLink}" class="v-stack justify-items-center gap-4 sm:gap-5 group">
                    <div class="overflow-hidden">
                      <img src="${promoImage}" alt="" width="1440" height="1400" loading="lazy" sizes="315px" class="zoom-image group-hover:zoom">
                    </div>
                    <div class="v-stack text-center gap-0.5">
                      <p class="h6">${promoTitle}</p>
                      <p class="smallcaps text-xs text-subdued">${promoSubTitle}</p>
                    </div>
                  </a>
                </div>`;
              }
            } else {
              let links = category.items;
              let linksHTML = "";
              if (links && links.length > 0) {
                linksHTML = `<div class="header-sidebar__nested-linklist">`;
                links.map((link) => {
                  linksHTML += custom.createLink(link);
                });
                linksHTML += `</div>`;
              }
              let liClass = "";
              if (category.display_type == 'Mobile Only') {
                liClass = "mobile_only";
              }
              if (category.display_type == 'Desktop Only') {
                liClass = "desktop_only";
              }
              if (links && links.length > 0) {
                innerNavigation += `
                <ul class="header-sidebar__linklist divide-y unstyled-list" role="list">
                  <li style="opacity: 1; transform: translateY(0px);" class="${liClass}">
                    <details is="accordion-disclosure" class="group" aria-expanded="false">
                      <summary class="header-sidebar__linklist-button h6">${category.title}<span class="animated-plus group-expanded:rotate" aria-hidden="true"></span></summary>
                      ${linksHTML}
                  </details>
                </li>
                </ul>`;
              } else if (category.url || category.title) {
                innerNavigation += `
                <ul class="header-sidebar__linklist divide-y unstyled-list" role="list">
                  <li style="opacity: 1; transform: translateY(0px);" class="${liClass}">
                    <a href="${custom.fetchLinkWithLocal(category.url)}" class="header-sidebar__linklist-button h6">${category.title}</a>
                  </li>
                </ul>`;
              }
            }

          });
          detailsHTML.innerHTML += `
            <div id="${item.handle}" class="header-sidebar__sub-panel" hidden="">
              <button type="button" class="header-sidebar__back-button link-faded is-divided text-with-icon h6 md:hidden" data-action="close-panel">
                  <svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-chevron-left  icon--direction-aware" viewBox="0 0 10 10">
                  <path d="M7 1 3 5l4 4" stroke="currentColor" stroke-linecap="square"></path>
                  </svg>
                  ${item.name}
              </button>
              ${innerNavigation}
            </div>`;
        }
      });
      mobileDiv.innerHTML = menuHTML;
    }
  },
  callNostoNavigation: function (openMenuTitle, currentPage) {
    let navigation_test = custom.getAttribute("navigation_test");
    if (navigation_test) {
      //Show default navigation if nosto is turned off
      custom.createNavigation(navigation_test, openMenuTitle, currentPage);
    } else {
      setTimeout(function () {
        let fullMenuElem = document.getElementById("nosto-menu-desktop");
        if (fullMenuElem) {
          if (fullMenuElem.innerHTML == "") {
            custom.createNavigation("default", openMenuTitle, currentPage);
          }
        }
      }, 500);
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements(["navigation-menu"])
          .load()
          .then((data) => {
            if (custom.getAttribute("debugnav")) {
              let now = Date.now();
              console.warn("Navigation Load Time: ", now - before + " ms");
              console.log("Response:", data);
            }
            let menuKeyStr = "default";
            if (
              data.recommendations["navigation-menu"] &&
              data.recommendations["navigation-menu"] != "undefined"
            ) {
              let menu = data.recommendations["navigation-menu"];
              if (menu.html) {
                menuKeyStr = menu.html;
              } else {
                menuKeyStr = menu;
              }
            } else {
              menuKeyStr = "default";
            }

            if (menuKey && menuKeyStr != "undefined") {
              sessionStorage.setItem(menuKey, menuKeyStr); //Update existing menu storage key
            }
            if (!currentMenuStorage) {
              custom.createNavigation(menuKeyStr, openMenuTitle, currentPage);
            }
          });
      });
    }
  },
  cleanNav: function (str) {
    let cleanedString = str.replace(/[\t\n\r]+/g, "");
    //remove tabs
    cleanedString = cleanedString.replace(/\t/g, "");
    cleanedString = cleanedString.replace(/ {2,}/g, " "); // Strip 2 or more spaces
    cleanedString = cleanedString.replace(', ]', ']');
    cleanedString = cleanedString.replace(',]', ']');//There's a scenario where the json object is not valid and has a trailing comma due to the date being invalid but liquid is checking for last item in loop

    // Parse the cleaned string as JSON
    try {
      const parsedJSON = JSON.parse(cleanedString);
      return parsedJSON;
    } catch (error) {
      console.error("Invalid JSON string:", error);
      return null; // Or you can throw an error or handle it as needed
    }
  },
  getAttribute: function (str) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(str);
  },
  getSetDateTimestamp: function () {
    let setDate = custom.getAttribute('SETDATE');
    if (!setDate) return null;
    const shortYearSlashDatePattern = /^\d{1,2}\/\d{1,2}\/\d{2}$/;
    if (shortYearSlashDatePattern.test(setDate)) {
      const parts = setDate.split('/');
      parts[2] = '20' + parts[2];
      setDate = parts.join('/');
    }
    const timestamp = new Date(setDate).getTime();
    if (Number.isNaN(timestamp)) return null;
    return Math.floor(timestamp / 1000);
  },
  removeCookie: function (cookie, domain, removeWww) {
    if (removeWww) {
      const wwwPrefix = "www.";
      domain = domain.replace(wwwPrefix, "");
    }
    // remove cookie by expiring it
    document.cookie = cookie + "=; domain=" + domain + "; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },
  getCookie: function (cookie) {
    let name = cookie + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  updateBreadCrumbs: function () {
    document.addEventListener("DOMContentLoaded", function () {
      var collectionContainer = document.querySelector(".product-banner-custom");
      var urlParams = new URLSearchParams(window.location.search);
      var collectionHandle = urlParams.get("collection_handle");
      var collectionName = urlParams.get("collection_name");
      const localData = localStorage.getItem("current_collection");
      let fromSearch = urlParams.get("_ss");
      let hide_breadcrumb = false;
      if (fromSearch == 'r') {
        hide_breadcrumb = true;
      }
      if (localData) {
        let json = JSON.parse(localData);
        collectionName = json.name ? json.name : collectionName;
        collectionHandle = json.handle ? json.handle : collectionHandle;
      } else {
        hide_breadcrumb = true;
      }

      if (hide_breadcrumb && collectionContainer) {
        var breadcrumbAnchor = collectionContainer.querySelector(
          "#breadcrumb_collection"
        );

        breadcrumbAnchor.parentElement.style.display = "none";
        return;
      }
      if (collectionContainer && collectionName && collectionHandle) {
        collectionContainer.style.display = "block";
        var breadcrumbAnchor = collectionContainer.querySelector(
          "#breadcrumb_collection"
        );
        if (breadcrumbAnchor) {
          breadcrumbAnchor.textContent = collectionName;
          let collectionUrl = "/collections/" + encodeURIComponent(collectionHandle);
          breadcrumbAnchor.href = custom.fetchLinkWithLocal(collectionUrl);
        }
      }
    });
  },
  gaTrackClickEvent: function (json, handle) {
    let creative_name = json['creative_name'];
    json['event'] = 'cta_click';
    json['cta_id'] = `${creative_name}|${handle}`;
    if (typeof ElevarDataLayer !== "undefined" && ElevarDataLayer) {
      ElevarDataLayer.push(json);
    }
  },
  gaTrackContentView: function (section_id, section_name, page_name) {
    let sections = document.querySelectorAll('section');
    let position = 0;
    let creative_name = "";
    let slides = [];
    let currentSection = null;
    sections.forEach((section, index) => {
      let sectionId = section.getAttribute('id');
      if (sectionId == ('shopify-section-' + section_id)) {
        position = index;
        currentSection = section;
        let imageElem = section.querySelector('img');
        if (imageElem) {
          creative_name = imageElem.getAttribute('src');
        }
        if (section_id.indexOf("featured_collection") > -1 || section_id.indexOf("rich_text") > -1) {
          let gaElement = section.querySelector('.ga-header');
          if (gaElement) {
            creative_name = section.querySelector('.ga-header').innerHTML;
          }
        }
        else if (section_id.indexOf("slideshow") > -1) {
          slides = section.querySelectorAll('.slideshow__slide');
        }
      }
    });

    let promotion_id = section_name;
    let promotion_name = section_name;
    let creative_slot = `${page_name}-${position}`;
    if (slides.length > 0) {
      slides.forEach((slide) => {
        if (slide) {
          let creative = slide.querySelector('img');
          if (creative) {
            creative_name = creative.getAttribute('src');
          }
          custom.renderGAJSonObject(promotion_id, promotion_name, creative_name, creative_slot, slide);
        }
      });
    } else {
      custom.renderGAJSonObject(promotion_id, promotion_name, creative_name, creative_slot, currentSection);
    }
  },
  renderGAJSonObject: function (promotion_id, promotion_name, creative_name, creative_slot, section) {
    let json = {
      'event': 'view_content',
      'promotion_id': promotion_id,
      'promotion_name': promotion_name,
      'creative_name': custom.parseImageName(creative_name),
      'creative_slot': creative_slot
    }

    let anchorTags = section.querySelectorAll('a');
    if (anchorTags) {
      anchorTags.forEach((anchor) => {
        anchor.addEventListener('click', function (event) {
          event.preventDefault();
          let url = anchor.getAttribute('href');
          let lastSlashIndex = url.lastIndexOf('/');
          let selectedText = url.substring(lastSlashIndex + 1);
          custom.gaTrackClickEvent(json, selectedText);
          if (!custom.getAttribute('disable_link')) {
            window.location.href = url;
          }

        });
      });
    }
    let sectionId = section.getAttribute('id');
    if (!sectionId) {
      sectionId = section.closest('section').getAttribute('id');
    }
    json['section_id'] = sectionId;
    custom.storedContentViews.push(json);
  },
  parseImageName: function (imageUrl) {
    if (!imageUrl.includes('/')) {
      return imageUrl;
    }
    const imageName = imageUrl.split('/').pop().split('?')[0];
    return imageName;
  },
  handleNostoDoNotTrack: function (domain) {
    let preferenceCategoryGranted;
    const oneTrustCookie = custom.getCookie("OptanonConsent");
    if (isAvon == 1) {
      preferenceCategoryGranted = "2:1";
    } else {
      preferenceCategoryGranted = "C0003:1";
    }
    const consentGranted = new URLSearchParams(oneTrustCookie).get("groups")?.split(",").includes(preferenceCategoryGranted) ?? false;
    nostojs(api => api.visit.setDoNotTrack(!consentGranted));
    nostojs(api => api.setAutoLoad(false));
    document.addEventListener("visitorConsentCollected", (event) => {
      if (event.detail.preferencesAllowed == true) {
        nostojs(api => api.visit.setDoNotTrack(false));
      } else {
        nostojs(api => api.visit.setDoNotTrack(true));
        custom.removeCookie("2c.cId", domain, true);
      }
    });
  },
  isElementInViewport: function (element) {
    const rect = element.getBoundingClientRect();
    return (
      (rect.y - rect.height) < 0 && rect.top > 0
    );
  },
  checkForStoredContentViews: function () {
    if (custom.storedContentViews.length > 0) {
      custom.storedContentViews.forEach((json, index) => {
        const element = document.getElementById(json.section_id);
        if (element && custom.isElementInViewport(element)) {
          delete json.section_id;
          if (typeof ElevarDataLayer !== "undefined" && ElevarDataLayer) {
            ElevarDataLayer.push(json);
            custom.storedContentViews.splice(index, 1);
          }
        }
      });
    }
  },
  lookForExternalLinks: function(host) {
    var parts = host.split('.');
    var rootDomain = parts.slice(-2).join('.');
    var isInternal = function(hostname) {
      return hostname === rootDomain || hostname.endsWith('.' + rootDomain);
    };
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      if (href.indexOf('http') !== 0) return;
      try {
        var url = new URL(href, window.location.href);
        if (!isInternal(url.hostname)) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      } catch (e) {
        return;
      }
    });
  },
  filterNostoProducts: function (
    collectionId,
    resultsId,
    sort,
    pageNum,
    filter,
    filterValid,//This is needed to be able to use a valid json object. The above filter is for graphQL which is not a valid json structure
    use_default,
    allow_scroll
  ) {

    window.scrollTo({ top: 0 });
    if (sort) {
      this.filters.sort = sort;
    } else {
      this.filters.sort = "";
    }
    if (!this.pageSet) {
      let sortFilter = custom.getAttribute('filter.sort');
      let filterUrl = custom.getAttribute('filter');
      if (sortFilter) {
        this.filters.sort = sortFilter;
        let sortContainer = document.getElementById('nosto-sort-list');
        if (sortContainer) {
          window.onload = function () {
            sortContainer.querySelectorAll('li').forEach((item) => {
              let btn = item.querySelector('.custom-select--item-active');
              let val = btn.getAttribute('data-value');
              if (val == sortFilter) {
                document.getElementById('nosto-search').querySelector('.custom-select--text').innerHTML = btn.innerHTML;
              }
            });
          };
        }
      }

      if (filterUrl) {

        let filters = filterUrl.split("||");
        this.filtersArray = filters;
        filter = "";
        filters.forEach((ft, ftidx) => {
          if (ft) {
            let filterArr = ft.split("*");
            let param = filterArr[0];
            let val = filterArr[1];
            let outputValue = `"${val}"`;
            if (val.indexOf(",") != -1) {
              outputValue = "";
              let valArr = val.split(",");
              valArr.forEach((output, idx) => {
                outputValue += `"${output}"`
                if ((idx + 1) < valArr.length) {
                  outputValue += ',';
                }
              });
            }
            filter += `{field: "${param}",value: [${outputValue}]}`;
            if ((ftidx + 1) < filters.length) {
              filter += ',';
            }
          }
        })
        filter = `[${filter}]`;
        let jsonStr = custom.convertFilterToValidJson(filter);
        filterValid = jsonStr;
      }
    }

    if (filter) {
      this.filters.filter = filter;
    }
    if (filterValid) {
      this.filters.filterValid = filterValid;
    }
    this.pageSet = true;
    if (collectionId) {
      this.filters.collectionId = collectionId;
    }
    if (resultsId) {
      this.filters.resultsId = resultsId;
    }

    if (!pageNum) {
      pageNum = 0;
    }
    this.filters.pageNum = pageNum;

    collectionId = this.filters.collectionId;
    resultsId = this.filters.resultsId;
    sort = this.filters.sort;
    pageNum = this.filters.pageNum;
    filter = this.filters.filter;

    if (filter) {
      document.querySelector('.active-facets').style.display = '';
      let filterObj = JSON.parse(this.filters.filterValid);
      let activeFacets = document.querySelector('.active-facets');
      activeFacets.innerHTML = "";
      if (activeFacets) {

        let divs = activeFacets.querySelectorAll('.active-facets__button');
        divs.forEach(div => div.remove());
        filterObj.forEach((ft) => {

          ft.value.forEach((val) => {
            let filterRemove = this.fetchLinkTemplate(val, ft.field);
            activeFacets.innerHTML += filterRemove;
          });
        });
      }
    }

    if (document.querySelector('.active-facets')) {
      let hasFacets = document.querySelector('.active-facets').innerHTML.trim();
      if (hasFacets == "") {
        document.querySelector('.active-facets').style.display = 'none';
      } else {
        document.querySelector('.active-facets').style.display = '';
      }
    }


    let resultsDiv = document.getElementById(resultsId);

    if (!resultsDiv) {
      return false;
    }
    if (allow_scroll) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    let field = "price";
    if (sort == "newest") {
      sort = "desc";
      field = "datePublished";
    }
    if (sort == "hightest_discount") {
      sort = "desc";
      field = "stats.discount";
    }
    let filterJson = "";
    if (filter) {
      filterJson = `filter: ${filter}`;
    }
    let sortField = "";
    let categoryField = `categoryId: "${collectionId}"`;
    if (sort != "") {
      sortField = `
        sort: [{field: "${field}", order: ${sort}}]
      `;
    }
    if (!collectionId) {
      categoryField = "";
    }
    let queryField = "";
    if (custom.getAttribute('q') && custom.isSearchPage) {
      queryField = `query: "${custom.getAttribute('q')}",`;
    }


    let hasActiveFilter = !!(filter && filter !== '[]') || !!(filterValid && filterValid !== '[]');
    let defaultKey = "use-default-account-id-" + collectionId;
    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
        localStorage.setItem(defaultKey, Date.now());
      }
    }
    // When a filter is active, ignore the cached default flag and try the
    // primary account first — filters may only exist on one account.
    // The retry with use_default=true still fires on failure.
    let defaultTs = parseInt(localStorage.getItem(defaultKey));
    if (!hasActiveFilter) {
      if (defaultTs && (Date.now() - defaultTs) < 300000) {
        accountId = theme.settings.defaultNostoId;
      } else if (defaultTs) {
        localStorage.removeItem(defaultKey);
        custom.currAccountId = null;
      }
    }
    let pageCt = this.paginationCt ? this.paginationCt : 0;
    let fromCt = pageNum * pageCt;

    let query = `query {
        search (accountId: "${accountId}",${queryField}
          products: {
            ${categoryField}${sortField}
            size: ${this.paginationCt}
            from: ${fromCt}
            ${filterJson}
          }) 
          {
            redirect
            products {
              hits {
                name
                thumbUrl
                price
                listPrice
                productId
                url
              }
              total
            }
        }
      }`;

    if (!resultsDiv) {
      return;
    }
    resultsDiv.innerHTML = "";
    if (custom.getAttribute("debugrec")) {
      console.log("graphql request", query);
    }
    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (custom.getAttribute("debugrec")) {
          console.log("graphql response", result);
        }
        let errors = result.errors;
        let hasError = false;
        let hasProducts = false;
        let redirect = "";
        if (result.data && result.data.search) {
          redirect = result.data.search.redirect;
        }
        if (redirect) {
          location.href = redirect;
          return;
        }
        if (result.data.search && result.data.search.products) {
          let hits = result.data.search.products.hits;
          hasProducts = hits.length > 0;
          if (custom.isSearchPage && custom.getAttribute("q")) {
            const collectionDescriptionElement = document.querySelector('.collection-description');
            if (collectionDescriptionElement) {
              let translatedTxt = collectionDescriptionElement.textContent.replace('0', '');
              collectionDescriptionElement.textContent = `${hits.length} ${translatedTxt}`;
              collectionDescriptionElement.style.display = 'block';
            }
          }
        }
        if (errors && errors.length > 0) {
          hasError = true;
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
        }
        if (custom.getAttribute("no-nosto") == "true") {//Use this to emulate nosto being down
          custom.handleNostoNoResults();
        }
        else if (!hasProducts) {
          if (!use_default) {
            custom.filterNostoProducts(collectionId, resultsId, sort, pageNum, filter, filterValid, true);
          } else {
            custom.handleNostoNoResults();
          }
        }
        else if (result && result.data) {
          let categoryQuery = {
            products: {
              "categoryId": collectionId,
              "size": this.paginationCt,
              "from": fromCt
            }
          };
          if (filter) {
            let filterNoQuotesConverted = sanitizeAndConvertToJson(filterJson.replace("filter: ", ""));
            let jsonTrackFilter = JSON.parse(filterNoQuotesConverted);
            categoryQuery = {
              products: {
                "categoryId": collectionId,
                "size": this.paginationCt,
                "from": fromCt,
                "filter": jsonTrackFilter
              }
            };
          }
          if (custom.getAttribute('from_key') == 'true' || custom.getAttribute('q')) {
            custom.trackNostoSearchPage(query, result);
          } else {
            custom.trackNostoCategoryPage(categoryQuery, result.data.search, theme.settings.collection_title);
          }

          custom.currAccountId = accountId;
          let hits = result.data.search.products.hits;
          let totalProducts = result.data.search.products.total;
          if (totalProducts == 0) {
            custom.handleNostoNoResults();
          }
          let numberOfPages = Math.ceil(totalProducts / this.paginationCt);
          let shop_symbol = custom.fetchShopSymbol();
          let promotionsShown = [];
          let ftRendered = false;
          hits.forEach((product, idx) => {
            let pageNumIdx = pageNum * custom.paginationCt + idx + 1;
            if (!custom.isSearchPage && collectionPromotions && collectionPromotions[pageNumIdx]) {
              custom.renderFillerTile(collectionPromotions[pageNumIdx], idx);
              ftRendered = true;
              promotionsShown.push(pageNumIdx);
            }
            let productUrl = product.url;
            productArr = productUrl.split("/");
            let productHandle = productArr[productArr.length - 1];
            let isGallery = theme.settings.is_gallery;
            if (productHandle) {
              document.getElementById("nostoProducts").innerHTML +=
                custom.prefetchProduct(productHandle, product);
              custom.getPdpItem(productHandle, false, undefined, undefined, undefined, undefined, false, isGallery);
            }
          });
          //add any filler tiles whose position is greater than the total products
          if (collectionPromotions) {
            collectionPromotions.forEach((collectionPromo, idx) => {
              if ((idx - (pageNum * custom.paginationCt)) > hits.length && !promotionsShown.includes(idx) && !ftRendered) {
                custom.renderFillerTile(collectionPromo, idx);
              }
            });
          }
          let pages = "";
          let dotsHTML = `<span class="pagination__link pagination__link--disabled h6">…</span>`;
          let lastPage = `<a is="facet-link" class="pagination__link h6"   onclick="custom.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${numberOfPages - 1},null,null,false,true);">${numberOfPages}</a>`;
          let firstPage = `<a is="facet-link" class="pagination__link h6"  onclick="custom.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',0,null,null,false,true);">1</a>`;
          let nextLink = `<a is="facet-link" class="pagination__link h6" rel="next" onclick="custom.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${pageNum + 1},null,null,false,true);"><svg aria-hidden="true" focusable="false" fill="none" width="11" class="icon icon-chevron-right  icon--direction-aware" viewBox="0 0 10 10">
          <path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"></path>
        </svg></a>`;
          let prevLink = `<a is="facet-link" class="pagination__link h6" rel="prev" onclick="custom.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${pageNum - 1},null,null,false,true);"><svg aria-hidden="true" focusable="false" fill="none" width="11" class="icon icon-chevron-left  icon--direction-aware" viewBox="0 0 10 10">
          <path d="M7 1 3 5l4 4" stroke="currentColor" stroke-linecap="square"></path>
        </svg></a>`;
          for (i = 0; i < numberOfPages; i++) {
            if (numberOfPages < 6) {
              if (pageNum == i) {
                pages += `<span class="pagination__link pagination__link--disabled h6" aria-current="page">${i + 1}</span>`
              } else {
                pages += `<a is="facet-link" class="pagination__link h6" aria-label="Go to page 2"  onclick="custom.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${i},null,null,false,true);">${i + 1}</a>`
              }
            } else {
              if (pageNum < 5) {//Always show the and last page
                if (i < 5) {
                  if (i == 0 && pageNum > 0) {
                    pages += prevLink;
                  }
                  if (pageNum == i) {
                    pages += `<span class="pagination__link pagination__link--disabled h6" aria-current="page">${i + 1}</span>`
                  } else {
                    pages += `<a is="facet-link" class="pagination__link h6" onclick="custom.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${i},null,null,false,true);">${i + 1}</a>`;
                  }
                }
                if (i == 6) {
                  pages += dotsHTML + lastPage;
                }
              }
              else {
                if (i == 0) {
                  pages += prevLink + firstPage + dotsHTML;
                }
                if (i > (pageNum - 3) && i < (pageNum + 3)) {
                  if (pageNum == i) {
                    pages += `<span class="pagination__link pagination__link--disabled h6" aria-current="page">${i + 1}</span>`
                  } else {
                    pages += `<a is="facet-link" class="pagination__link h6" onclick="custom.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${i},null,null,false,true);">${i + 1}</a>`;
                  }
                } else if (i == numberOfPages - 1 && numberOfPages > pageNum + 3) {
                  pages += dotsHTML + lastPage;
                }
                // pages += dotsHTML + lastPage;
              }
              if (i == (numberOfPages - 1) && pageNum != (numberOfPages - 1)) {
                pages += nextLink;
              }
            }


            //pages += `<li class="${className}"><a class="pagination__link h6" href="javascript:void(custom.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${i},null,null,false,true));">${i + 1}</a></li>`;
          }
          document.getElementById("nosto-collection-pagination").innerHTML =
            pages;

          let productsCount = document.querySelector('.collection-toolbar__products-count');
          if (productsCount) {
            if (totalProducts == 1) {
              let elemOne = productsCount.querySelector('.collection-name-one');
              if (elemOne) {
                let productsArr = elemOne.innerHTML.split(" ");
                let productsName = productsArr[1];
                productsCount.innerHTML = `<span class="collection-name-one">${totalProducts} ${productsName}</span><span class="collection-name-other"></span>`;
                elemOne.style.display = 'block';
                if (theme.settings.nostoSearc && custom.getAttribute('q')) {
                  productsCount.innerHTML += ` for "${custom.getAttribute('q')}"`;
                }
              }
            } else {
              let elemOne = productsCount.querySelector('.collection-name-other');
              if (elemOne) {
                elemOne.innerHTML = elemOne.innerHTML.replace("{{ count }}", "0");
                let productsArr = elemOne.innerHTML.split(" ");
                let productsName = productsArr[1];
                productsCount.innerHTML = `<span class="collection-name-one"></span><span class="collection-name-other">${totalProducts} ${productsName}</span>`;
                elemOne.style.display = 'block';
                if (theme.settings.nostoSearch && custom.getAttribute('q')) {
                  productsCount.innerHTML += ` for "${custom.getAttribute('q')}"`;
                }
              }
            }

          }
          if (!custom.filtersChecked) {
            custom.checkFilters(custom.filtersArray);
          }
        } else {
          custom.handleNostoNoResults(collectionId);
        }
      });
  },
  renderFillerTile: function (collectionPromo, idx, liquidPromo) {
    if (!collectionPromo) {
      return false;
    }
    let image = collectionPromo.image;
    let heading = collectionPromo.heading;
    let bodyColor = collectionPromo.body_color;
    let useTextButton = collectionPromo.use_text_button;
    let dimensions = collectionPromo.dimensions || '1x1';
    let blackOverlay = collectionPromo.black_overlay;
    let buttonStyle = collectionPromo.button_style;
    let buttonBackground = collectionPromo.button_background;
    let buttonForeground = collectionPromo.button_foreground;

    let contentPosition = collectionPromo.content_position;
    let contentAlignment = collectionPromo.content_alignment;
    let url = collectionPromo.url;
    let buttonUrl = collectionPromo.button_url;
    let description = collectionPromo.description;
    let headingSize = collectionPromo.heading_style;
    let buttonLabel = collectionPromo.button_label;
    let columnWidth = collectionPromo.columns;

    // Parse dimensions to get width class
    let widthClass = '';
    switch (dimensions) {
      case '1x2':
        widthClass = 'promotion-column-width--1x2';
        break;
      case '2x1':
        widthClass = 'promotion-column-width--2x1';
        break;
      case '2x2':
        widthClass = 'promotion-column-width--2x2';
        break;
      case '1x1':
      default:
        widthClass = 'promotion-column-width--1x1';
        break;
    }
    let descriptionContent = "";
    if (description) {
      descriptionContent = `<p class="mo-promo-description" data-live-text-setting="">${description}</p>`;
    }
    let buttonLabelContent = "";
    if (buttonLabel) {
      if (useTextButton || buttonStyle == "Link") {
        buttonLabelContent = `<a class="text-button ${buttonStyle} text-button--has-icon" style="color:${buttonForeground};" href="${buttonUrl}" data-live-text-setting="">${buttonLabel}</a>`
      } else {
        let button_style = `color:${buttonForeground};background:${buttonBackground};`
        if (buttonStyle == 'Outline Button') {
          button_style = `color:${buttonForeground};border: solid 1px ${buttonBackground};background: transparent;`
        }
        buttonLabelContent = `<a class="mo-promo-button button ${buttonStyle} medium" style="${button_style}" href="${buttonUrl}" data-live-text-setting="">${buttonLabel}</a>`;
      }
    }
    let headingContent = "";
    if (heading) {
      headingContent = `<h2 class="${headingSize}" data-live-text-setting="">${heading}</h2>`;
    }
    let overlay = "";
    if (blackOverlay > 0) {
      overlay = `--overlay-color-rgb: 0,0,0;  --overlay-opacity: ${blackOverlay}`;
    }

    let infoSection = "";
    if (heading || description || buttonLabel) {
      infoSection = `
      <a href="${url}">
      <div class="gallery--item-content content-${contentPosition} text-${contentAlignment}">
        <div class="prose" style="color:${bodyColor}">
          ${headingContent}
          ${descriptionContent}
          ${buttonLabelContent}
        </div>
      </div>
      </a>
    `;
    }

    // Your product card HTML
    let productCard = `
    <product-card class="promotion-column column ${widthClass} product-columns-4">
      <div class="gallery--item" data-shopify-editor-block="" style="${overlay}">
        <figure class="aspect-ratio">
          <a href="${url}"><img class=" " width="2760" height="1765" data-sizes="auto" src="${image}" data-srcset="${image}" fetchpriority="auto" alt="" style="object-position: 50.0% 50.0%;"></a>
          <noscript>
            <img width="2760" height="1765" sizes="auto" src="${image}" srcset="${image}" alt="${heading}" fetchpriority="auto" style="object-position: 50.0% 50.0%;" />
          </noscript>
          ${infoSection}
        </figure>
      </div>
    </product-card>
    `;

    // Insert the product card next to the selected product
    if (liquidPromo) {
      // Get all products (use querySelectorAll for multiple elements)
      let allProducts = document.querySelectorAll('.product-list product-card');
      let product = allProducts[idx - 1]; // Now this will work - gets the second product
      if (product) {
        product.insertAdjacentHTML('beforebegin', productCard);
      }
    } else {
      document.querySelector(".product-list").innerHTML += productCard;
    }
  },
  applyFillerTiles: function () {
    collectionPromotions.forEach((promo, idx) => {
      if (promo) {
        custom.renderFillerTile(promo, idx, true);
      }
    });
  },
  handleNostoNoResults: function () {
    let handle = location.href.split('/').pop().split('?')[0];
    //location.href = '/pages/collection-no-nosto/' + handle;
  },
  checkFilters: function (filters) {
    custom.filtersChecked = true;

    filters.forEach((ft, ftidx) => {
      if (ft) {
        let filterArr = ft.split("*");
        let param = filterArr[0];
        let val = filterArr[1];
        if (val.indexOf(",") != -1) {
          let valArr = val.split(",");
          valArr.forEach((output, idx) => {
            let elem = document.getElementById(`${param}_${output}`);
            if (elem) {
              elem.checked = true;
            }
          });
        } else {
          let elem = document.getElementById(`${param}_${val}`);
          if (elem) {
            elem.checked = true;
          }
        }
      }
    })
  },
  getPdpItem: function (handle, small, sectionId, sectionOnly, slotId, fromSearch, prefetchId, fromGallery) {
    var pageBody = document.getElementById('main');
    if (!pageBody.classList.contains('collection') || theme.settings.is_gallery != 'true') {
      fromGallery = false;
    } else {
      fromGallery = true;
    }
    let productUrl = this.parseUrl(handle, small, fromSearch, fromGallery);
    fetch(productUrl)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        if (html.indexOf("<product-card>No product found.</product-card>") !== -1) {
          let elem = document.querySelector(prefetchId);
          if (!elem) {
            let section = "";
            if (sectionId) {
              section = sectionId + "-";
            }
            elem = document.querySelector(".product-" + section + handle);
            elem.style.display = 'none';
          }
          return false;
        }
        let loading = document.querySelector(".loading");
        if (loading) {
          loading.style.display = "none";
        }
        let prod = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(".product_card");
        let prodSmall = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(".product_card_small");
        let prodStats = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(".product_stats");

        let prodSide = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(".product_card_side");
        if (prod) {
          let prodCard = prod.querySelector('product-card');
          let prodCardSmall = prodSmall.querySelector('product-card');
          let prodCardHorizontal = prodSide.querySelector('.horizontal-product-card');
          // The feed page renders empty card shells when all_products[handle]
          // resolves to nothing (product unpublished/unavailable in this
          // market or channel). Remove the placeholder instead of swapping in
          // a blank card with no image/title/price.
          let mainCardProductId = prod.querySelector('[product-id]')?.getAttribute('product-id') ||
                                  prod.querySelector('input.product-id')?.value;
          if (!mainCardProductId) {
            if (custom.getAttribute('debugrec')) {
              console.warn('Empty product card for handle "' + handle + '" — product not available in this storefront context, removing placeholder');
            }
            let section = sectionId ? sectionId + '-' : '';
            let placeholderElem = document.querySelector(prefetchId) || document.querySelector('.product-' + section + handle);
            placeholderElem?.remove();
            if (sectionId === 'side-cart') {
              let remaining = document.querySelectorAll('#shopify-section-side-cart .horizontal-product-card').length;
              custom.handleCartRecDots(remaining);
            }
            return false;
          }
          let placeholder = prod.querySelector('.thb-placeholder');
          let anchorLink = prod.querySelector('.product-title');
          let imageAnchor = prod.querySelector('.product-card__media');
          if (slotId) {
            if (anchorLink) {
              anchorLink.setAttribute('nosto-slot-id', slotId);
            }
            if (prodCard) {
              prodCard.setAttribute('nosto-slot-id', slotId);
            }
            if (prodCardSmall) {
              prodCardSmall.setAttribute('nosto-slot-id', slotId);
            }
            if (prodCardHorizontal) {
              prodCardHorizontal.setAttribute('nosto-slot-id', slotId);
            }
            let buttonElem = prodSide && prodCardHorizontal;
            if (buttonElem) {
              buttonElem.setAttribute('nosto-slot-id', slotId);
            }
            if (imageAnchor) {
              imageAnchor.setAttribute('nosto-slot-id', slotId);
            }
          }
          let prodHTML = prod.innerHTML;
          let section = "";
          if (sectionId) {
            section = sectionId + "-";
          }
          if (sectionOnly) {
            if (sectionId) {
              if (placeholder) {
                sectionId.style.display = 'none';
                return false;
              } else {
                sectionId.innerHTML = prodHTML;
                sectionId.style.display = '';
              }
            }
          } else {
            let elem = document.querySelector(prefetchId);
            if (!elem) {
              elem = document.querySelector(".product-" + section + handle);
            }

            if (elem) {
              let productCard = prod.querySelector('product-card');
              if (prodStats && prodStats.innerHTML) {
                productCard.innerHTML += prodStats.innerHTML;
              }
              let productCardSmall = prodSmall.querySelector('product-card');
              let productCardSide = prodSide.querySelector('.horizontal-product-card');
              let insertedElement;

              if (elem.parentElement.classList.contains('side-cart-scroll') || elem.parentElement.classList.contains('side-cart')) {
                if (productCardSide) {
                  elem.replaceWith(productCardSide);
                  insertedElement = productCardSide;
                }
              }
              else if (small) {
                elem.innerHTML = `
                  <div class="md:hidden">
                    ${productCardSmall.innerHTML}
                  </div>
                  <div class="md-max:hidden">
                      ${productCard.outerHTML}
                  </div>`;
                insertedElement = elem;
              } else {
                if (productCard) {
                  // Replace element in DOM and then hide sibling info
                  elem.replaceWith(productCard);
                  insertedElement = productCard;
                  custom.testSiblingInfoDisplay(productCard);
                  custom.handleDiscountChecking(productCard);
                }
              }

              // Initialize features for the inserted element
              if (insertedElement) {
                // Use requestAnimationFrame to ensure DOM is fully updated
                requestAnimationFrame(() => {
                  const carousel = insertedElement.querySelector('scroll-carousel');
                  if (carousel) {
                    carousel.scrollLeft = 0;
                    // Initialize infinite scroll for dynamically loaded carousel
                    if (typeof window.initInfiniteScroll === 'function') {
                      window.initInfiniteScroll(carousel);
                    }
                  }
                  // Initialize hover alternate image for dynamically loaded product card
                  if (typeof window.initAltImageHover === 'function') {
                    window.initAltImageHover(insertedElement);
                  }
                  // Re-check swatch overflow for dynamically loaded product cards (Nosto PLP)
                  // Double rAF ensures layout/paint is complete before measuring overflow
                  if (typeof window.checkSwatchOverflow === 'function') {
                    requestAnimationFrame(() => {
                      window.checkSwatchOverflow();
                    });
                  }
                  // Autoplay video if present
                  const video = insertedElement.querySelector('video');
                  if (video) {
                    video.style.width = '100%';
                    video.style.height = '100%';
                    const playsInline = video.getAttribute('playsinline');
                    if (playsInline === 'playsinline' || playsInline === 'true') {
                      const playVideo = () => video.play();
                      if (video.readyState >= 1) {
                        playVideo();
                      } else {
                        video.addEventListener('loadedmetadata', playVideo, { once: true });
                        video.load();
                      }
                      insertedElement?.offsetHeight; // Force reflow to resize product card and prevent cropping of video
                    }
                  }
                });
              }
            }

            let sectionId2 = "product-grid-" + sectionId;
            custom.updateFlickity(sectionId2);
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            //Reset the carousel to the beginning
            if (sectionId) {
              let section = document.getElementById("shopify-section-" + sectionId);
              if (section) {
                const carousel = section.querySelector('scroll-carousel'); // Reset carousel scroll position to 0
                if (carousel) {
                  carousel.scrollLeft = 0;
                }
                custom.testSiblingInfoDisplay(section);
              }
            }
          }
        }
      });

  },
  handleDiscountChecking: function (prodCard) {
    let priceList = prodCard.querySelector('price-list');
    if (!priceList) return;
    let productIdElem = priceList.querySelector('.product-id');
    let hasSalePriceElem = priceList.querySelector('.do_sale_price');

    if (hasSalePriceElem && productIdElem) {
      let hasSalePrice = hasSalePriceElem.value;
      let productId = productIdElem.value;
      if (productId && hasSalePrice == "true") {
        custom.validateSalePrice(productId);
      }
    }

  },
  parseUrl: function (handle, small, fromSearch, fromGallery) {
    let feedType = "-regular";
    let productUrl = `/pages/nosto${feedType}-feed/${handle}`;
    if (theme.settings.locale != "" && theme.settings.locale != custom.default_lang) {
      custom.updateLocale();
      productUrl = `/${theme.settings.locale}/pages/nosto${feedType}-feed/${handle}`;
    }
    if (fromSearch && small) {
      productUrl += "*from_search";
    }

    if (fromGallery == true) {
      if (theme.settings.locale != "" && theme.settings.locale != custom.default_lang) {
        custom.updateLocale();
        productUrl = `/${theme.settings.locale}/products/${handle}?section_id=product-card-gallery-nosto-plp`;
      } else {
        productUrl = `/products/${handle}?section_id=product-card-gallery-nosto-plp`;
      }

    }
    return productUrl;
  },
  parsePageUrl: function (handle) {
    let pageUrl = `/pages/${handle}`;
    if (theme.settings.locale != "" && theme.settings.locale != custom.default_lang) {
      custom.updateLocale();
      pageUrl = `/${theme.settings.locale}/pages/${handle}`;
    }
    return pageUrl;
  },
  testSiblingInfoDisplay: function (elem) {
    let siblingInfo = elem.querySelector(".product-siblings-color-info");
    if (siblingInfo && !custom.isProductPage) {
      siblingInfo.style.display = "none";
    }
  },
  fetchShopSymbol: function () {
    let shop_symbol = theme.settings.money_with_currency_format.trim();
    if (
      shop_symbol.substring(shop_symbol.length - 1) !== "}" &&
      shop_symbol.substring(shop_symbol.length - 1).length > 0
    ) {
      shop_symbol = shop_symbol.substring(shop_symbol.length - 1);
    } else {
      shop_symbol = shop_symbol.substring(0, 1);
    }
    return shop_symbol;
  },
  trackNostoSearchClick: function (productId, url, type) {

    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearchClick: ', 'apicall': 'api.recordSearchClick', 'productID': productId, 'URL': url, 'Type': type });
    }
    nostojs(api => {
      let hit = {
        productId: productId,
        url: url,
      }
      api.recordSearchClick(type, hit);
    });
  },
  trackNostoCart: function (cartItems) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCart: ', 'apicall': 'api.setCart', 'cart_items': cartItems });
    }
    let placementId = custom.placementId;
    let sideCartSection = document.getElementById('shopify-section-side-cart');
    nostojs(api => {
      let session = api.defaultSession()
        .setCart({
          items: cartItems
        })
        .viewCart();
      if (placementId && sideCartSection) {
        session
          .setPlacements([placementId])
          .update()
          .then((response) => {
            if (custom.getAttribute("debug_tracking")) {
              console.log({ 'method': 'trackNostoCart: ', 'apicall': 'session.update', 'response': response });
            }
            let cartPlacement = response && response.recommendations && response.recommendations[placementId];
            // Only clear + refill when the cart-context response actually has
            // products. A placement that comes back empty here must not wipe
            // recommendations that are already rendered (e.g. right after the
            // drawer re-renders on a quantity change).
            if (cartPlacement && cartPlacement.products && cartPlacement.products.length > 0) {
              let productListElem = sideCartSection.querySelector('product-list');
              if (productListElem) {
                let sideCartScroll = productListElem.querySelector('.side-cart-scroll');
                if (sideCartScroll) {
                  sideCartScroll.innerHTML = '';
                } else {
                  productListElem.innerHTML = '';
                }
              }
              custom.sideCartRecLoaded = true;
              custom.handleNostoProductResponse(
                placementId,
                'side-cart',
                custom.numberOfProducts,
                false,
                custom.locale,
                undefined,
                response
              );
            }
          })
          .catch((error) => {
            console.error("Error calling Nosto:", error);
          });
      } else {
        session.update()
          .catch((error) => {
            console.error("Error calling Nosto:", error);
          });
      }
    });
  },
  trackNostoRecommendationsCartAdd: function (productId, slotId) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoRecommendationsCartAdd: ', 'apicall': 'api.recommendedProductAddedToCart', 'productId': productId, 'slotId': slotId });
    }
    nostojs(api => {
      api.recommendedProductAddedToCart(productId, slotId);
    });
  },
  trackNostoCartAdd: function (productId, url, fromSearch) {
    let searchPage = window.location.href.indexOf("/search") != -1;
    let categoryPage = window.location.href.indexOf("/collections") != -1;
    let type = '';
    if (custom.getAttribute('q') == 'true') {
      searchPage = true;
    }
    if (fromSearch) {
      type = 'autocomplete';
    } else if (searchPage) {
      type = 'serp';
    }
    else if (categoryPage) {
      type = 'category';
    }

    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCartAdd ', 'apicall': 'api.recordSearchAddToCart', 'productId': productId, 'url': url, 'type': type });
    }
    nostojs(api => {
      let hit = {
        productId: productId,
        url: url,
      }
      api.recordSearchAddToCart(type, hit)
    });


  },
  trackNostoCategoryClick: function (productId, url) {

    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }

    let type = 'category';
    if (custom.getAttribute('q') == 'true') {
      type = 'serp';
    }

    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCategoryClick: ', 'apicall': 'api.recordSearch', 'productId': productId, 'url': url, type: type });
    }
    nostojs(api => {
      let hit = {
        productId: String(productId),
        url: url,
      }
      api.recordSearchClick(type, hit);
    });
  },
  trackNostoCategoryPage: function (searchRequest, searchResult, categoryName) {//Impressions

    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCategoryPage: ', 'apicall': 'api.recordSearch', 'SearchRequest': searchRequest, 'SearchResult': searchResult });
    }
    let option = {};
    option.isKeyword = false;
    nostojs(async (api) => {
      api.recordSearch(
        'category',
        searchRequest,
        searchResult,
        {
          isKeyword: false
        }
      )
    });
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCategoryPage: ', 'apicall': 'api.recordAttribution', 'type': 'vc', 'target': categoryName });
    }
    nostojs(api => api.recordAttribution({
      type: "vc",
      target: categoryName,
    })
      .done()
    );
  },
  trackNostoSearchPage: function (query, result) {//Impressions
    let searchTerm = custom.getAttribute('q');
    let option = {};
    let type = "serp";
    if (custom.getAttribute('from_key') == 'true') {
      option.isKeyword = true;
      type = "autocomplete";
    } else if (custom.getAttribute("q")) {
      custom.trackNostoSearchSubmit(searchTerm);
    }
    custom.trackNostoSearch(type, query, result.data.search, option, searchTerm);
  },
  trackNostoSearch: function (type, searchRequest, searchResult, options, searchTerm) {//Impressions
    searchRequest = {
      query: searchTerm,
      products: {
        sort: [{ field: "price", order: "asc" }]
      }
    }

    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearch: ', 'apicall': 'api.recordSearch', 'Type': type, 'SearchRequest': searchRequest, 'SearchResult': searchResult, 'options': options });
    }

    nostojs(async (api) => {
      api.recordSearch(
        type,
        searchRequest,
        searchResult,
        options
      )
    })
  },
  trackNostoClick: function (slotId, productId) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': "trackNostoClick", 'apicall': 'api.recordAttribution', 'SlotID': slotId, 'ProductID': productId });
    }
    nostojs(api => api.recordAttribution({
      type: "vp",
      target: productId,
      ref: slotId,
      refType: "api"
    })
      .done()
    );
  },
  trackNostoRecommendationsCartAdd: function (productId, slotId) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoRecommendationsCartAdd: ', 'apicall': 'api.recommendedProductAddedToCart', 'productId': productId, 'slotId': slotId });
    }
    nostojs(api => {
      api.recommendedProductAddedToCart(productId, slotId);
    });
  },
  updateFlickity: function (sliderId) {
    let slider = document.getElementById(sliderId);
    if (slider) {
      flkty = Flickity.data(slider);
      if (flkty) {
        flkty.reloadCells();
      }
    }
  },
  prefetchProduct: function (productSectionHandle, product, horizontal) {
    let title = product.name;
    let thumbUrl = product.thumbUrl;
    if (!thumbUrl) {
      thumbUrl = product.thumb_url;
    }
    let productTemplate = "";
    if (horizontal) {
      productTemplate = `
      <div class="horizontal-product-card product-${productSectionHandle}"><a href="#" class="horizontal-product-card__figure" data-instant="">
      <img src="${thumbUrl}" alt="Silk Popover Shirt" srcset="${thumbUrl}" width="1600" height="2000" loading="lazy" sizes="100px" class="horizontal-product-card__image"></a>
      <div class="horizontal-product-card__info">
    <div class="v-stack gap-1 justify-items-start">
      <a href="#" class="product-title h6" data-instant="">${title}</a><price-list class="price-list  "><sale-price class="h6 text-on-sale">
        </div>
        
        </div>
</div>
                `;
    } else {
      productTemplate = `
    <product-card class="product-${productSectionHandle}" handle="short-sleeve-tech-tee-795100786-035">
      <div class="product-card__figure">
        <div class="badge-mo badge-bottom-right "></div>
        <img src="${thumbUrl}" alt="" srcset="${thumbUrl}" width="1600" height="2000" loading="lazy"
          sizes="(max-width: 699px) 74vw, (max-width: 999px) 38vw, calc((100vw - 96px) / 3 - (24px / 3 * 2))"
          class="product-card__image product-card__image--primary  aspect-natural">
        <img src="${thumbUrl}" alt="" srcset="${thumbUrl}" width="1600" height="2000" loading="lazy"
          class="product-card__image product-card__image--secondary" fetchpriority="low"
          sizes="(max-width: 699px) 74vw, (max-width: 999px) 38vw, calc((100vw - 96px) / 3 - (24px / 3 * 2))">
      </div>
      <div class="product-card__info empty:hidden" style="margin-top:20px;">
        <div class="v-stack justify-items-center gap-1">
          <div class="v-stack justify-items-center gap-1">
            <a href="/products/short-sleeve-tech-tee-795100786-035" class="product-title h6 line-clamp"
              style="--line-clamp-count: 2" data-instant="">${title}</a>
          </div>
        </div>
      </div>
    </product-card>
              `;
    }
    return productTemplate;
  },
  linkToURL: function (url, anchor, event) {
    if (event) event.preventDefault();
    let doCategoryClick = false;
    let searchPage = window.location.href.indexOf("/search") != -1;
    let categoryPage = window.location.href.indexOf("/collections") != -1;
    let sectionContainerElem = anchor.closest('.shopify-section');
    let sectionSearchContainerElem = anchor.closest('predictive-search');
    // If the anchor is inside a section, we need to check if it has a nosto-slot-id or product-id
    let horizontalCardElem = anchor.closest('.horizontal-product-card');
    if (horizontalCardElem) {
      if (horizontalCardElem.getAttribute('nosto-slot-id')) {
        anchor.setAttribute('nosto-slot-id', horizontalCardElem.getAttribute('nosto-slot-id'));
      }
      if (horizontalCardElem.getAttribute('product-id')) {
        anchor.setAttribute('product-id', horizontalCardElem.getAttribute('product-id'));
      }
    }
    // If the anchor is inside a section, we need to check if it has a nosto-slot-id or product-id
    let productCardElem = anchor.closest('.product-card');
    if (productCardElem) {
      if (productCardElem.getAttribute('nosto-slot-id')) {
        anchor.setAttribute('nosto-slot-id', productCardElem.getAttribute('nosto-slot-id'));
      }
      if (productCardElem.getAttribute('product-id')) {
        anchor.setAttribute('product-id', productCardElem.getAttribute('product-id'));
      }
    }

    let featuredContainerElem = anchor.closest('.featured-collections-carousel');
    if (featuredContainerElem) {
      doCategoryClick = true;
    }
    if (anchor && anchor.getAttribute("nosto-slot-id")) {
      let slotId = anchor.getAttribute("nosto-slot-id");
      let productId = anchor.getAttribute("product-id");
      custom.trackNostoClick(slotId, productId);
    }
    else if (sectionSearchContainerElem) {
      if (anchor) {
        let productId = anchor.getAttribute("product-id");
        custom.trackNostoSearchClick(productId, url, 'autocomplete');
      }
    } else if (searchPage) {
      let type = 'serp';
      if (custom.getAttribute('from_key')) {
        type = 'autocomplete';
      }
      custom.trackNostoSearchClick(anchor.getAttribute("product-id"), url, type);
    } else if (categoryPage || doCategoryClick) {
      custom.trackNostoCategoryClick(anchor.getAttribute("product-id"), url);
    } else {

    }
    let skipRedirect = false;
    if (anchor.type === "submit") {
      skipRedirect = true;
    }
    if (!skipRedirect) {
      setTimeout(() => {
        window.location.href = url;
      }, 500);
    }

  },
  fetchLinkTemplate: function (linkName, linkField) {
    let removeLinkTemplate = `<div class="removable-facet">
    <a onclick="custom.updateFilterItem('${linkField}','${linkName}');" class="tap-area link-faded"
      aria-label="Remove filter &quot;${linkName}&quot;" data-no-instant=""><svg aria-hidden="true"
        focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
        <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.8"></path>
      </svg>
    </a>
    <span class="text-subdued">${linkName}</span>
  </div>`;
    return removeLinkTemplate
  },
  convertFilterToValidJson: function (json_str) {
    if (json_str) {
      json_str = json_str.replace('}{', '},{');
      json_str = json_str.replace(/value/g, '"value"');
      json_str = json_str.replace(/field/g, '"field"');
    }
    return json_str;
  },
  createFilters: function (collectionId, use_default) {
    if (!collectionId) {
      collectionId = this.currCollectionId;
    }
    this.currCollectionId = collectionId;

    let formElem = document.getElementById("facets-drawer");
    if (formElem) {
      //formElem.innerHTML = "";
      let query = custom.getFilterQuery(use_default);
      if (custom.getAttribute("debugrec")) {
        console.log("graphql request filters", query);
      }
      fetch("https://search.nosto.com/v1/graphql", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: query,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          let errors = result.errors;
          let hasError = false;
          if (errors && errors.length > 0) {
            hasError = true;
            if (custom.getAttribute("debugrec")) {
              console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
            }
          }

          if (hasError) {
            if (!use_default) {
              custom.createFilters(collectionId, true);
              return;
            }
          }
          else if (!result.data || !result.data.search || !result.data.search.products || !result.data.search.products.facets || result.data.search.products.facets.length == 0) {
            if (!use_default) {
              custom.createFilters(collectionId, true);
              return;
            }
          }
          else if (result && result.data) {
            let accordion = document.querySelector('.accordion-list');
            let mobileAccordion = document.getElementById('mobileFilters');
            if (accordion) {
              accordion.innerHTML = "";
            }
            if (mobileAccordion) {
              mobileAccordion.innerHTML = "";
            }
            let facets = result.data.search.products.facets;
            if (facets && facets.length > 0) {
              facets.forEach((facet) => {
                if (!facet) {
                  return;
                }
                let facetName = facet.name;
                let facetField = facet.field;
                let facetValues = facet.data;
                let liHTML = "";
                if (facetValues && facetValues.length > 0) {
                  facetValues.forEach((item) => {
                    let value = item.value;
                    let count = item.count;
                    let className = convertToLettersAndNumbers(`${facetField}_${value}`);
                    liHTML += `
                    <div class="checkbox-control">
                    <input
                      class="${className} dot-checkbox" type="checkbox" name="${facetField}"
                      value="${value}"><label
                      for="checkbox-facets-sidebar-1-template--15546369474632__main--filter.p.m.custom.product_sub_category-blazers-amp-suiting">
                      <a  onclick="custom.updateFilterItem('${facetField}', '${value}');">
                      <span class="color-sample filter-${value.toLowerCase()}"></span> ${value} <span id="${facetField}${value}_ct" class="count">(${count})</span></label>
                      </a>
                    </div>`;
                  });
                }
                let categoryHTML = `
                <details class="accordion  group " is="accordion-disclosure" aria-expanded="false">
                  <summary><span class="accordion__toggle h6"><span class="text-with-icon gap-4">${facetName}</span><svg
                        aria-hidden="true" focusable="false" fill="none" width="10" class="group-expanded:rotate icon icon-chevron-down"
                        viewBox="0 0 10 10">
                        <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
                      </svg></span>
                  </summary>

                  <div class="accordion__content ">
                  ${liHTML}
                  </div>
                </details>`;

                if (accordion) {

                  accordion.innerHTML += categoryHTML;
                }
                if (mobileAccordion) {
                  mobileAccordion.innerHTML += categoryHTML;
                }
                // formElem.innerHTML += categoryHTML;
              });

            }

            let facetsDrawer = document.getElementById("facets-drawer");
            if (facetsDrawer) {
              facetsDrawer.innerHTML += `
              <div slot="footer">
              <button style="width:100%;" class="button apply-filter-button" type="button" is="dialog-close-button" part="close-button tap-area" aria-label="${theme.settings.translations.apply_filters}" onclick="custom.refreshProducts();">
                ${theme.settings.translations.apply_filters}
              </button>
              </div>`;
            }
          }
          if (custom.loadProducts) {
            custom.loadProducts = false;

            custom.filterNostoProducts(collectionId, 'nostoProducts', "", 0, null, false, use_default)
          }
        });
    }
  },
  getFilterQuery: function (use_default) {
    let collectionId = this.currCollectionId;
    let hasActiveFilter = !!(custom.filters.filter && custom.filters.filter !== '[]');
    let categoryFilter = "";
    if (collectionId) {
      categoryFilter = `products:{
        categoryId:"${collectionId}"
        filter: ${custom.filters.filter}
      }`;
    }
    let defaultKey = "use-default-account-id-" + collectionId;
    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
        localStorage.setItem(defaultKey, Date.now());
      }
    }
    // When a filter is active, ignore the cached default flag and try the
    // primary account first — filters may only exist on one account.
    let defaultTs = parseInt(localStorage.getItem(defaultKey));
    if (!hasActiveFilter) {
      if (defaultTs && (Date.now() - defaultTs) < 300000) {
        accountId = theme.settings.defaultNostoId;
      } else if (defaultTs) {
        localStorage.removeItem(defaultKey);
        custom.currAccountId = null;
      }
    }
    let queryField = "";
    if (custom.getAttribute('q') && custom.isSearchPage) {
      queryField = `query: "${custom.getAttribute('q')}",`;
    }
    let query = `query {
      search(
        ${queryField}
        ${categoryFilter}
        accountId: "${accountId}") {
        products {
          facets {
            ... on SearchTermsFacet {
              id
              field
              type
              name
              data {
                value
                count
              }
            }
          }
        }
      }
    }`;
    return query;
  },
  refreshProducts: function () {
    let mobileForm = document.getElementById("FacetFiltersFormDesktop");
    let textinputs = mobileForm
      ? mobileForm.querySelectorAll("input[type=checkbox]")
      : "";
    let checked = [].filter.call(textinputs, function (el) {
      return el.checked;
    });
    let jsonFilter = [];
    let jsonFilterValid = [];
    let allFilters = {};

    checked.forEach((input) => {
      let name = input.getAttribute("name");
      let value = input.getAttribute("value");
      if (!allFilters[name]) {
        allFilters[name] = [];
      }
      allFilters[name].push(value);
    });
    let idx = 0;
    let filtersCt = Object.keys(allFilters).length;
    for (var fieldName in allFilters) {
      idx++;
      if (allFilters.hasOwnProperty(fieldName)) {
        let values = JSON.stringify(allFilters[fieldName]);
        let json = `{ field: "${fieldName}", value: ${values} }`;
        let jsonValid = `{ "field": "${fieldName}", "value": ${values} }`;
        if (idx < filtersCt) {
          jsonValid += ",";
        }
        jsonFilter += json;
        jsonFilterValid += jsonValid;
      }
    }
    let currentFilter = localStorage.getItem("current-product-filter");
    let storeFilter = JSON.stringify(jsonFilter);
    if (storeFilter != currentFilter) {
      localStorage.setItem("current-product-filter", storeFilter);
      jsonFilter = `[${jsonFilter}]`;
      jsonFilterValid = `[${jsonFilterValid}]`;
      this.filterNostoProducts(null, null, null, null, jsonFilter, jsonFilterValid);
    }
  },
  updateFilterItem: function (field, value) {
    let selectorID = convertToLettersAndNumbers(`${field}_${value}`);
    let filterItems = document.querySelectorAll('.' + selectorID);
    let isChecked = !filterItems[0].checked;
    filterItems.forEach((item) => {
      item.checked = isChecked;
    });

    this.refreshProducts();
    this.updateFilterUrl();
    custom.updateFilters();
  },
  updateFilterUrl: function () {
    if (this.filters.filterValid) {
      let json = JSON.parse(this.filters.filterValid);
      let responseUrl = "?";
      if (custom.getAttribute('q')) {
        responseUrl = `?q=${custom.getAttribute('q')}&`;
      }
      responseUrl += "filter=";
      json.forEach((filter) => {
        let values = filter.value;
        let param = filter.field;
        responseUrl += `||${param}*${values}`
      });
      window.history.pushState('page2', 'Title', responseUrl)
    }
  },
  updateFilters: function () {
    let query = custom.getFilterQuery();
    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let errors = result.errors;
        if (errors && errors.length > 0) {
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
          return;
        }
        else if (result && result.data) {
          let facets = result.data.search.products.facets;
          if (facets && facets.length > 0) {
            facets.forEach((facet) => {
              let facetField = facet.field;
              let facetValues = facet.data;
              facetValues.forEach((item) => {
                let value = item.value;
                let count = item.count;
                let countElem = document.getElementById(`${facetField}${value}_ct`);
                countElem.innerHTML = `(${count})`;
              });
            });
          }
        }
      });

  },
  removeFilter: function (currVal, currField) {
    let cbId = currField + currVal;
    let elem = document.getElementById(cbId);
    if (elem) {
      elem.checked = false;
      custom.refreshProducts();
      document.querySelector('.click-capture').click()
    }
    this.updateFilterUrl();
  },
  callNostoSection: function (placementId, sectionId, type) {
    if (!type) {
      return;
    }

    this.hideVisible("shopify-section-" + sectionId);
    let nosto_debug = custom.getAttribute("nosto_debug");
    if (nosto_debug) {
      let json = { handle: nosto_debug };
      custom.handleNostoSectionResponse(json, sectionId, type);
    } else if (custom.nostoApiKey != "") {
      nostojs((api) => {
        api
          .defaultSession()
          .setResponseMode("HTML")
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {

            if (response.recommendations.hasOwnProperty(placementId)) {

              let json = JSON.parse(response.recommendations[placementId]);
              custom.handleNostoSectionResponse(json, sectionId, type);
            } else {
              this.hide("shopify-section-" + sectionId);
            }
          })
          .catch((error) => {
            console.error("Error calling Nosto:", error);
          });
      });
    } else {
      custom.hide("shopify-section-" + sectionId);
    }
  },
  handleNostoSectionResponse: function (json, sectionId, type) {
    custom.hideVisible("shopify-section-" + sectionId);

    let handle = json.handle;
    if (!handle) {
      return false;
    }
    this.callMetaobjectAPI(handle, sectionId, type);
  },
  callMetaobjectAPI: function (handle, sectionId, type) {

    let apiPath = type;
    let setDateTimestamp = custom.getSetDateTimestamp();
    if (setDateTimestamp) {
      handle += '_' + setDateTimestamp;
    }
    let metaobjectUrl = window.location.origin + custom.parsePageUrl(`metaobject-api/${apiPath}*${handle}`);
    fetch(metaobjectUrl)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        let json = "";
        if (data) {
          try {
            json = JSON.parse(data);
          } catch (error) {
            console.error("Failed to parse JSON response:", error);
            json = {}; // Default to an empty object
          }
        }
        custom.handleMetaObjectReponse(json, 'shopify-section-' + sectionId, type)
      });
  },
  hide: function (elem_id) {
    document.getElementById(elem_id).style.display = "none";
  },
  show: function (elem_id) {
    document.getElementById(elem_id).style.display = "block";
  },
  hideVisible: function (elem_id) {
    if (document.getElementById(elem_id)) {
      document.getElementById(elem_id).style.visibility = "hidden";
    }
  },
  showVisible: function (elem_id) {
    document.getElementById(elem_id).style.visibility = "";
    if (document.getElementById(elem_id).querySelector('.loader'))
      document.getElementById(elem_id).querySelector('.loader').style.visibility = '';
  },
  handleNostoDefault: function (metaobject, collectionSectionid, type) {
    if (metaobject && metaobject[type] && metaobject[type].length == 0) {
      console.error(`${type} failed to get metaobject`)
      this.hide(collectionSectionid);
      return false;
    }
    return true;
  },
  handleMetaObjectReponse: function (metaobject, collectionSectionid, type) {
    if (!metaobject[type] || !Array.isArray(metaobject[type]) || !metaobject[type][0] || !metaobject[type][0].data) {
      document.getElementById(collectionSectionid).style.display = "none";
      return false;
    }
    let metaobjectData = metaobject[type][0].data;
    if (!custom.handleNostoDefault(metaobject, collectionSectionid, type)) {
      return false;
    }

    if (type == 'image_with_text' && metaobjectData.layout == "Image With Text Overlay") {
      this.handleImageWithTextOverlay(metaobjectData, collectionSectionid);
    } else if (type == 'image_with_text') {
      this.handleImageWithText(metaobjectData, collectionSectionid);
    } else if (type == 'image_with_text_overlay') {
      this.handleImageWithTextOverlay(metaobjectData, collectionSectionid);
    } else if (type == 'slideshow') {
      this.handleSlideshow(metaobjectData, collectionSectionid);
    } else if (type == 'scrolling_text') {
      this.handleScrollingText(metaobjectData, collectionSectionid);
    } else if (type == 'rich_text') {
      this.handleRichText(metaobjectData, collectionSectionid);
    } else if (type == 'collection_list') {
      this.handleCollectionList(metaobjectData, collectionSectionid);
    } else if (type == 'featured_collection') {
      this.handleFeaturedCollection(metaobjectData, collectionSectionid);
    } else if (type == 'announcement_bar') {
      this.handleAnnouncementBar(metaobjectData, collectionSectionid);
    } else if (type == 'shop_the_look') {
      this.handleShopTheLook(metaobjectData, collectionSectionid);
    }
  },
  handleCollectionList: function (metaobject, collectionSectionid) {
    //Add data checking here
    let heading = document.getElementById(collectionSectionid).querySelector('.mo-header-heading');
    if (heading && heading.innerHTML != "") {
      heading.innerHTML = metaobject.heading;
    }
    let subheading = document.getElementById(collectionSectionid).querySelector('.mo-header-subheading');
    if (subheading && subheading.innerHTML != "") {
      subheading.innerHTML = metaobject.sub_heading;
    }
    let description = document.getElementById(collectionSectionid).querySelector('.mo-header-content');
    if (description && description.innerHTML != "") {
      description.innerHTML = metaobject.description;
    }

    if (metaobject.background_color) {
      document.getElementById(collectionSectionid).querySelector('.color-scheme').style.backgroundColor = metaobject.background_color;
      document.getElementById(collectionSectionid).querySelector('.section-stack').style.padding = "20px";
    }
    if (metaobject.foreground_color) {
      document.getElementById(collectionSectionid).querySelector('.section-stack').style.color = metaobject.foreground_color;
    }
    let slides = document.getElementById(collectionSectionid).querySelectorAll('.collection-card');
    slides.forEach((slide, idx) => {
      if (metaobject.collections[idx]) {
        custom.handleCustomCollectionSlide(metaobject.collections, slide, idx);
      } else {
        slide.style.display = 'none';
      }
    });
    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  handleCustomCollectionSlide: function (metaobject, slide, idx) {

    let imageSrc = metaobject[idx].image;
    if (slide.querySelector('.mo-image').querySelector('img')) {
      slide.querySelector('.mo-image').querySelector('img').setAttribute(
        "src",
        imageSrc
      );
      slide.querySelector('.mo-image').querySelector('img').setAttribute(
        "srcset",
        imageSrc
      );
    }
    let link = metaobject[idx].url;
    if (link) {
      const moLink = slide.querySelector('.mo-link');
      let buttonLabel = metaobject[idx].button_label;
      slide.setAttribute('href', link);
      if (moLink) {
        if (buttonLabel) {
          moLink.innerHTML = buttonLabel;
        } else {
          moLink.style.display = 'none';
        }
      }
    }
    if (slide.querySelector('.mo-title') && slide.querySelector('.mo-title').innerHTML != "") {
      slide.querySelector('.mo-title').innerHTML = metaobject[idx].title;
    }

    if (slide.querySelector('.mo-description') && slide.querySelector('.mo-description').innerHTML != "") {
      slide.querySelector('.mo-description').innerHTML = metaobject[idx].description;
    }
  },
  getLookupPosition: function (metaobject, handle) {
    let position = -1;
    metaobject.products.forEach((product, idx) => {
      if (product.product_handle == handle) {
        position = idx;
      }
    });
    return position;
  },
  handleShopTheLook: function (metaobject, collectionSectionid) {
    let desktopCarousel = document.getElementById(collectionSectionid).querySelector('shop-the-look-desktop-carousel');
    let mobileCarousel = document.getElementById(collectionSectionid).querySelector('shop-the-look-mobile-carousel');

    if (!desktopCarousel || !mobileCarousel) {
      return;
    }
    const sectionEl = document.getElementById(collectionSectionid);
    const headerEl = sectionEl ? sectionEl.querySelector('.mo-header-heading') : null;
    if (headerEl) {
      headerEl.innerHTML = metaobject.title;
    }
    custom.renderImage(collectionSectionid, 'shop-the-look-desktop-carousel .mo-main-image', metaobject.main_image);
    custom.renderImage(collectionSectionid, 'shop-the-look-mobile-carousel .mo-main-image', metaobject.main_image);
    let productCard = document.getElementById(collectionSectionid).querySelectorAll('.mo-product-card');
    productCard.forEach((card, idx) => {
      card.innerHTML = '';
      if (metaobject.products[idx]) {
        let handle = metaobject.products[idx].product_handle;
        if (handle) {
          let productUrl = this.parseUrl(handle, false, null, null);
          fetch(productUrl)
            .then((response) => {
              return response.text();
            })
            .then((html) => {
              let parser = new DOMParser();
              let doc = parser.parseFromString(html, 'text/html');
              let productCardHtml = doc.querySelector('product-card');
              let productHandle = productCardHtml.getAttribute('handle');
              if (productCardHtml) {
                card.innerHTML = '';
                card.replaceWith(productCardHtml);
              }
              let lookPopover = document.getElementById(collectionSectionid).querySelector('shop-the-look-popover');
              if (lookPopover && productHandle) {
                let popoverCarousel = lookPopover.querySelector('scroll-carousel');
                if (popoverCarousel) {
                  let popoverProducts = popoverCarousel.querySelectorAll('.shop-the-look__item-product');
                  if(!popoverProducts) return;
                  let popoverProduct = popoverProducts[custom.getLookupPosition(metaobject, handle)];
                  if (!popoverProduct) return;
                  let productCardPopover = popoverProduct.querySelector('product-card');
                  if (productCardPopover && popoverProduct.getAttribute('has-product') != 'true') {
                    productCardPopover.replaceWith(productCardHtml.cloneNode(true));
                  }
                }
              }
            })
            .catch((error) => {
              console.error('Failed to load product card for URL:', productUrl, error);
            });

          let hotSpotList = desktopCarousel.querySelector('carousel-navigation.shop-the-look__hot-spot-list');
          if (hotSpotList) {
            let spotDot = hotSpotList.querySelectorAll('button')[idx];
            if (spotDot) {
              spotDot.style.setProperty('--shop-the-look-hot-spot-left', metaobject.products[idx].horizontal_position + '%');
              spotDot.style.setProperty('--shop-the-look-hot-spot-top', metaobject.products[idx].vertical_position + '%');
            }
          }
          let mobileSpotDot = mobileCarousel.querySelector('carousel-navigation.shop-the-look__hot-spot-list');
          if (mobileSpotDot) {
            mobileSpotDot = mobileSpotDot.querySelectorAll('button')[idx];
            if (mobileSpotDot) {
              mobileSpotDot.style.setProperty('--shop-the-look-hot-spot-left', metaobject.products[idx].horizontal_mobile_position + '%');
              mobileSpotDot.style.setProperty('--shop-the-look-hot-spot-top', metaobject.products[idx].vertical_mobile_position + '%');
            }
          }


        }
      } else {
        card.style.display = 'none';
        desktopCarousel.querySelector('carousel-navigation.page-dots').querySelectorAll('button')[idx].style.display = 'none';
        let hotSpotList = desktopCarousel.querySelector('carousel-navigation.shop-the-look__hot-spot-list');
        if (hotSpotList) {
          let spotDot = hotSpotList.querySelectorAll('button')[idx];
          if (spotDot) {
            spotDot.style.display = 'none';
          }
        }
        let mobileSpotDot = mobileCarousel.querySelector('carousel-navigation.shop-the-look__hot-spot-list');
        if (mobileSpotDot) {
          mobileSpotDot = mobileSpotDot.querySelectorAll('button')[idx];
          if (mobileSpotDot) {
            mobileSpotDot.style.display = 'none';
          }
        }

        let lookPopover = document.getElementById(collectionSectionid).querySelector('shop-the-look-popover');
        if (lookPopover) {
          let popoverCarousel = lookPopover.querySelector('scroll-carousel');
          if (popoverCarousel) {
            let popoverProducts = popoverCarousel.querySelectorAll('.shop-the-look__item-product');

            if (popoverProducts[idx]) {
              popoverProducts[idx].style.display = 'none';
            }
          }
        }

      }
    });


    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  handleRichText: function (metaobject, collectionSectionid) {
    custom.renderTextElement(collectionSectionid, '.mo-heading', metaobject.heading);
    custom.renderTextElement(collectionSectionid, '.mo-sub_heading', metaobject.sub_heading);
    custom.renderTextElement(collectionSectionid, '.mo-text', metaobject.text);
    if (metaobject.background_color) {
      document.getElementById(collectionSectionid).querySelector('.color-scheme').style.backgroundColor = metaobject.background_color;
    }
    if (metaobject.text_color) {
      document.getElementById(collectionSectionid).querySelector('.container').style.color = metaobject.text_color;
    }
    if (metaobject.content_position) {
      let contentElem = document.getElementById(collectionSectionid).querySelector('.prose');
      if (contentElem) {
        let buttonContainerElem = document.getElementById(collectionSectionid).querySelector('.button-group');
        if (buttonContainerElem) {
          buttonContainerElem.setAttribute('class', "button-group");
          contentElem.setAttribute('class', "prose");
          if (metaobject.content_position == 'Left') {
            contentElem.classList.add(`text-start`);
            buttonContainerElem.classList.add(`justify-start`);
          }
          else if (metaobject.content_position == 'Right') {
            contentElem.classList.add(`text-end`);
            buttonContainerElem.classList.add(`justify-end`);
          } else {
            contentElem.classList.add(`text-center`);
            buttonContainerElem.classList.add(`justify-center`);
          }
        }
      }
    }
    if (metaobject.buttons.length > 0) {
      let buttons = metaobject.buttons;
      let all_buttons = document.getElementById(collectionSectionid).querySelectorAll('.mo-button');
      //hide all buttons to start
      all_buttons.forEach((btn) => {
        btn.style.display = 'none';
      });
      all_buttons.forEach((button, idx) => {
        custom.renderButton(collectionSectionid, '.mo-button', buttons[idx], button, true);
      });

    }

    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  renderButton: function (collectionSectionid, selector, button, anchor, doMainLink) {
    let label = button.button_name;
    let link = button.url;
    let element = document.getElementById(collectionSectionid).querySelector(selector);
    if (theme.settings.locale != "") {
      custom.updateLocale();
      link = `/${theme.settings.locale}${link}`;
    }

    if (anchor) {
      element = anchor;
      element.style.display = 'inline-block';
    }

    if (!label && element) {
      element.style.display = 'none';
      return;
    }
    if (element && link && label) {
      if (element.type == 'button') {
        element.setAttribute('onclick', `location.href='${link}'`);
      } else {
        element.setAttribute('href', link);
      }
      element.innerHTML = label;
      element.style.display = 'inline-block';
    }
    if (button.button_style == 'Link') {
      element.style.color = button.foreground_color;
      element.classList.add('link');
      element.classList.remove('button');
    }
    else if (button.button_style == 'Outline Button') {
      element.style.color = button.foreground_color;
      element.style.background = 'transparent';
      element.style.border = '1px solid ' + button.foreground_color;
    } else if (button.button_style == 'Solid Button') {
      element.style.color = button.foreground_color;
      element.style.background = button.background_color;
      element.classList.add('button');
      element.classList.remove('link');
    }
    let section = document.getElementById(collectionSectionid);
    if (section && doMainLink) {
      let mainLink = section.querySelector('.main-link');
      if (mainLink && link && doMainLink) {
        mainLink.setAttribute('href', link);
      }
    }
  },
  handleImageWithTextOverlay: function (metaobject, collectionSectionid) {
    custom.renderTextElement(collectionSectionid, '.mo-heading', metaobject.heading);
    custom.renderTextElement(collectionSectionid, '.mo-subheading', metaobject.sub_heading);
    custom.renderTextElement(collectionSectionid, '.mo-text', metaobject.text);
    if (metaobject.desktop_text_color && !isMobileUserAgent()) {
      custom.setTextColor(collectionSectionid, metaobject.desktop_text_color, '.mo-heading');
      custom.setTextColor(collectionSectionid, metaobject.desktop_text_color, '.mo-subheading');
      custom.setTextColor(collectionSectionid, metaobject.desktop_text_color, '.mo-text');
    }
    if (metaobject.mobile_text_color && isMobileUserAgent()) {
      custom.setTextColor(collectionSectionid, metaobject.mobile_text_color, '.mo-heading');
      custom.setTextColor(collectionSectionid, metaobject.mobile_text_color, '.mo-subheading');
      custom.setTextColor(collectionSectionid, metaobject.mobile_text_color, '.mo-text');
    }
    let all_buttons = document.getElementById(collectionSectionid).querySelectorAll('.mo-button');
    //hide all buttons to start
    all_buttons.forEach((btn) => {
      btn.style.display = 'none';
    });
    metaobject.buttons.forEach((button, idx) => {
      custom.renderButton(collectionSectionid, '.mo-button', button, all_buttons[idx]);
    });
    custom.renderImage(collectionSectionid, '.mo-desktop-image', metaobject.desktop_image);
    custom.renderImage(collectionSectionid, '.mo-mobile-image', metaobject.mobile_image);
    let mobilePosition = metaobject.overlay_mobile_position;
    let desktopPosition = metaobject.overlay_desktop_position;
    let contentElem = document.getElementById(collectionSectionid).querySelector('.content');
    if (contentElem) {
      if (desktopPosition) {
        let positionClasses = custom.fetchPositionClass(desktopPosition);
        contentElem.classList.add(...positionClasses);
      }
      if (mobilePosition) {
        let positionClasses = custom.fetchPositionClass(mobilePosition);
        positionClasses = positionClasses.map(cls => cls.replace('sm:', ''));
        contentElem.classList.add(...positionClasses);
      }
    }


    this.showVisible(collectionSectionid);
  },
  setTextColor: function (collectionSectionid, textColor, selector) {
    let sectionElem = document.getElementById(collectionSectionid);
    if (!sectionElem) {
      return; //If the section is not found, do not proceed
    }
    let textElem = sectionElem.querySelector(selector);
    if (textElem) {
      textElem.setAttribute('style', `color:${textColor}`);
    }
  },
  setBackgroundColor: function (collectionSectionid, backgroundColor) {
    let sectionElem = document.getElementById(collectionSectionid);
    if (!sectionElem) {
      return; //If the section is not found, do not proceed
    }
    sectionElem.style.backgroundColor = backgroundColor;
  },
  renderTextElement: function (collectionSectionid, selector, text) {
    let sectionElem = document.getElementById(collectionSectionid);
    if (!sectionElem) {
      return; //If the section is not found, do not proceed
    }
    let textElem = document.getElementById(collectionSectionid).querySelector(selector);
    if (textElem && textElem.querySelector('p')) {
      textElem = textElem.querySelector('p');
    }
    if (textElem) {
      if (text) {
        textElem.innerHTML = text;
      } else {
        textElem.style.display = 'none';
      }
    }
  },
  handleImageWithText: function (metaobject, collectionSectionid) {
    let heading = document.getElementById(collectionSectionid).querySelector(".mo-heading");
    let subheading = document.getElementById(collectionSectionid).querySelector(".mo-subheading");
    let text = document.getElementById(collectionSectionid).querySelector(".mo-text");
    let desktopElem = document.getElementById(collectionSectionid).querySelector(".mo-desktop-image")
    let desktop_image = null;
    if (desktopElem) {
      desktop_image = desktopElem.querySelector('img');
    }
    let mobileElem = document.getElementById(collectionSectionid);
    let mobile_image = null;
    if (mobileElem) {
      mobile_image = document.getElementById(collectionSectionid).querySelector(".mo-mobile-image");
    }
    if (heading) {
      heading.innerHTML = metaobject.heading;
    }
    if (metaobject.image_position == 'Right') {
      let imageWithTextElem = document.getElementById(collectionSectionid).querySelector('.image-with-text');
      if (imageWithTextElem) {
        imageWithTextElem.classList.add('image-with-text--reverse');
      }
    }
    desktop_image.setAttribute('src', metaobject.desktop_image);
    desktop_image.setAttribute('srcset', metaobject.desktop_image);
    mobile_image.setAttribute('src', metaobject.mobile_image);
    mobile_image.setAttribute('srcset', metaobject.mobile_image);

    if (subheading) {
      subheading.innerHTML = metaobject.sub_heading;
    }
    if (text) {
      text.innerHTML = metaobject.text;
    }

    if (!isMobileUserAgent() && metaobject.desktop_text_color) {
      if (heading) {
        heading.setAttribute('style', `color:${metaobject.desktop_text_color}`);
      }
      if (subheading) {
        subheading.setAttribute('style', `color:${metaobject.desktop_text_color}`);
      }
      if (text) {
        text.setAttribute('style', `color:${metaobject.desktop_text_color}`);
      }
    }
    if (isMobileUserAgent() && metaobject.mobile_text_color) {
      if (heading) {
        heading.setAttribute('style', `color:${metaobject.mobile_text_color}`);
      }
      if (subheading) {
        subheading.setAttribute('style', `color:${metaobject.mobile_text_color}`);
      }
      if (text) {
        text.setAttribute('style', `color:${metaobject.mobile_text_color}`);
      }
    }

    let buttons;
    if (metaobject.buttons)
      buttons = metaobject.buttons.slice(0, 7);
    let buttonsInner = document.getElementById(collectionSectionid).querySelectorAll('.mo-button');
    buttonsInner.forEach((btn) => {
      btn.innerHTML = "";
      btn.setAttribute('href', '');
      btn.style.display = "none";
    });
    if (buttons && buttonsInner) {
      buttons.forEach((btn, idx) => {
        let button_name = btn.button_name;
        let button_url = btn.url;
        if (buttonsInner[idx]) {
          buttonsInner[idx].setAttribute('href', button_url);
          buttonsInner[idx].innerHTML = button_name
          buttonsInner[idx].style.display = "";
          if (btn.button_style == 'Outline Button') {
            buttonsInner[idx].setAttribute('style', `color:${btn.foreground_color}; border: 1px solid ${btn.background_color}; background:transparent`);
          } else {
            buttonsInner[idx].setAttribute('style', `color:${btn.foreground_color}; background:${btn.background_color}`);
          }

        }
      });
    }
    this.showVisible(collectionSectionid);
  },
  handleFeaturedCollection: function (metaobject, collectionSectionid) {
    if (document.getElementById(collectionSectionid)) {
      let carouselNav = document.getElementById(collectionSectionid).querySelector('carousel-navigation');
      let collectionLinks = [];
      if (carouselNav) {
        collectionLinks = carouselNav.querySelectorAll('button');
      }
      let viewAllButtons = document.getElementById(collectionSectionid).querySelectorAll('.mo-view-all');
      if (viewAllButtons && viewAllButtons.length > 0) {
        viewAllButtons.forEach((button, idx) => {
          if (metaobject.collections[idx]) {
            let url = '/collections/' + metaobject.collections[idx].handle;
            if (theme.settings.locale != "") {
              custom.updateLocale();
              url = `/${theme.settings.locale}${url}`;
            }
            button.setAttribute('href', url);
          }
        });
      }
      if (collectionLinks.length > 0) {
        collectionLinks.forEach((link, idx) => {
          if (idx > metaobject.collections.length - 1) {
            link.style.display = 'none';
          } else {
            if (link) {
              link.innerHTML = metaobject.collections[idx].title;
            }
          }
        });
      }

      metaobject.collections.forEach((collection, idx) => {
        custom.fetchFeaturedCollection(collection.id, false, collectionSectionid, idx);
      });
    }
  },
  fetchAccountID: function (use_default, collectionId) {
    let defaultKey = "use-default-account-id-" + (collectionId || "global");
    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
        localStorage.setItem(defaultKey, Date.now());
      }
    }
    let defaultTs = parseInt(localStorage.getItem(defaultKey));
    if (defaultTs && (Date.now() - defaultTs) < 300000) {
      accountId = theme.settings.defaultNostoId;
    } else if (defaultTs) {
      localStorage.removeItem(defaultKey);
      custom.currAccountId = null;
    }
    return accountId;
  },
  fetchFeaturedCollection: function (collectionId, use_default, collectionSectionid, idx) {
    if (document.getElementById(collectionSectionid)) {
      let accountId = custom.fetchAccountID(use_default, collectionId);
      let carousels = document.getElementById(collectionSectionid).querySelectorAll('.featured-collections-carousel__item');
      let carouselContainer = carousels[idx];
      if (carouselContainer) {
        const products = carouselContainer.querySelectorAll('product-card');
        let categoryField = `categoryId: "${collectionId}"`;
        let query = `query {
      search (accountId: "${accountId}"
        products: {
          size: ${products.length}
          ${categoryField}
        }) 
        {
          redirect
          products {
            hits {
              name
              thumbUrl
              price
              listPrice
              productId
              url
            }
            total
          }
      }
    }`;

        if (custom.getAttribute("debugrec")) {
          console.log("featured collection graphql request", query);
        }
        fetch("https://search.nosto.com/v1/graphql", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: query,
          }),
        })
          .then((res) => res.json())
          .then((result) => {
            let errors = result.errors;
            let hasError = false;

            if (errors && errors.length > 0) {
              hasError = true;
              console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
            }
            if (hasError) {
              if (!use_default) {
                custom.fetchFeaturedCollection(collectionId, true, collectionSectionid, idx);
              }
            } else if (result) {
              let products = result.data.search.products.hits;
              custom.renderFeaturedCollection(products, carouselContainer, collectionSectionid);

            }

          });
      }
    }
  },
  renderFeaturedCollection: function (products_data, carouselElem, collectionSectionid) {
    let element = carouselElem.querySelector('.mo-heading');
    if (element) {
      element.innerHTML = "";
    }
    const products = carouselElem.querySelectorAll('product-card');
    products.forEach((product, idx) => {
      product.remove();
    });

    let productCards = new Array(products_data.length).fill(null);
    let resolvedCount = 0;

    products_data.forEach((product, idx) => {

      let productUrl = products_data[idx].url;
      productArr = productUrl.split("/");
      let productHandle = productArr[productArr.length - 1];
      let isGallery = theme.settings.is_gallery == 'true';
      productUrl = this.parseUrl(productHandle);
      fetch(productUrl)
        .then((response) => {
          return response.text();
        })
        .then((html) => {
          let loading = document.querySelector(".loading");
          if (loading) {
            loading.style.display = "none";
          }
          let prod = new DOMParser().parseFromString(html, "text/html").querySelector(".product_card");
          if (isGallery) {
            const doc = new DOMParser().parseFromString(html, "text/html");
            const productCard = "product_card";
            prod = doc.body.firstElementChild || doc.querySelector("." + productCard);
          }
          if (prod) {
            let productCard = prod.querySelector('product-card');
            productCard.classList.add('meta-product-card');
            productCards[idx] = productCard.outerHTML;
          }
          resolvedCount++;
          if (resolvedCount === products_data.length) {
            let scrollElem = carouselElem.querySelector('scroll-carousel');
            let productList = carouselElem.querySelector('.product-list');
            let container = scrollElem || productList;
            if (container) {
              container.innerHTML += productCards.filter(Boolean).join('');
            } else {
              console.error('No container found for featured collection products');
            }
          }
        });

    });

    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  handleAnnouncementBar: function (metaobject, collectionSectionid) {
    let collectionSectionElem = document.getElementById(collectionSectionid);
    if (collectionSectionElem) {
      let carouselElem = collectionSectionElem.querySelector('announcement-bar-carousel');
      if (!carouselElem) {
        return;
      }
      let announcementItems = carouselElem.querySelectorAll('.heading');
      if (announcementItems) {
        let metaobjectItems = metaobject.items;
        if (metaobjectItems.length == 1) {
          let annBarElem = document.querySelector('.announcement-bar');
          if (annBarElem) {
            let buttons = annBarElem.querySelectorAll('button');
            buttons.forEach((button) => {
              button.style.display = 'none';
            });
          }

        }
        if (metaobjectItems.length == 2) {
          metaobjectItems = metaobjectItems.concat(metaobjectItems);
        }
        if (metaobjectItems.length == 3) {
          metaobjectItems.push(metaobject.items[1]);
        }
        announcementItems.forEach((item, idx) => {
          if (announcementItems[idx] && metaobjectItems[idx] && metaobjectItems[idx].content) {
            if (metaobjectItems[idx].expiration_date) {
              item.setAttribute('expiration-date', metaobjectItems[idx].expiration_date);
            }
            if (metaobjectItems[idx].link) {
              item.innerHTML = `<a href="${metaobjectItems[idx].link}"> ${metaobjectItems[idx].content}</a>`;
            } else {
              item.innerHTML = metaobjectItems[idx].content;
            }
          } else {
            announcementItems[idx].remove();
          }

        });
      }
      this.showVisible(collectionSectionid);
    }
  },
  handleSlideshow: function (metaobject, collectionSectionid) {
    let slideContentSlides = document.getElementById(collectionSectionid).querySelectorAll('.slideshow__slide');
    let slideshow = metaobject;
    slideContentSlides.forEach((slide, idx) => {

      if (idx < custom.maxSlideshows) {
        if (slideshow.slides[idx]) {
          custom.handleSlide(slideshow.slides[idx], slide);
        } else {
          slide.remove();
        }

      }
    })

    let dotContainerElem = document.getElementById(collectionSectionid).querySelector('carousel-navigation');
    if (dotContainerElem) {
      dotContainerElem.querySelectorAll('button').forEach((dot, idx) => {
        if ((idx + 1) > slideshow.slides.length) {
          dot.style.display = 'none';
        }
      });
    }

    slideContentSlides.forEach((slide, idx) => {
      if (slide) {
        let slide_buttons = "";
        let slide_button_container = slide.querySelector(".button-group");
        if (slide_button_container) {

          slide_buttons = slide_button_container.querySelectorAll("a");
        }
        if (slide_buttons && slideshow.slides[idx] && slideshow.slides[idx].buttons) {
          slide_buttons.forEach((button, btnidx) => {
            custom.handleButtons(slideshow.slides[idx].buttons[btnidx], button);
          });
        }
      }
    });
    let slideshowContent = document
      .getElementById(collectionSectionid)
      .querySelector(".slideshow__slide-content-link");

    if (
      metaobject.slidesURL &&
      metaobject.slidesURL.value &&
      metaobject.slidesURL.value != ""
    ) {
      slideshowContent.setAttribute("href", metaobject.slidesURL.value);
    }

    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  handleSlide: function (slide_data, slide) {
    let desktopElem = slide.querySelector("img");
    custom.renderSlideImage(desktopElem, slide_data);
    let slideImageLinkElem = slide.querySelector('.slide-img-link');
    if (slideImageLinkElem && slide_data.image_link && slide_data.image_link != '') {
      if (slide_data.image_link == "#") {
        slideImageLinkElem.replaceWith(document.createElement('span'));
      } else {
        slideImageLinkElem.setAttribute('href', custom.checkForLocale(slide_data.image_link));
      }
    }
    let mobileElem = slide.querySelector("source");
    custom.renderSlideImage(mobileElem, slide_data, true);
    let textColor = slide_data.desktop_color;
    if (isMobileUserAgent()) {
      textColor = slide_data.mobile_color;
    }

    let slideContent = slide.querySelector('.slideshow__slide-content');
    let mobilePosition = slide_data.mobile_position;
    let desktopPosition = slide_data.desktop_position;

    if (desktopPosition) {
      let positionClasses = custom.fetchPositionClass(desktopPosition);
      slideContent.classList.add(...positionClasses);
    }
    if (mobilePosition) {
      let positionClasses = custom.fetchPositionClass(mobilePosition);
      positionClasses = positionClasses.map(cls => cls.replace('sm:', ''));
      slideContent.classList.add(...positionClasses);
    }


    custom.renderSlideText(slide, '.nosto-slide-subheading', slide_data['subheading'], textColor);
    custom.renderSlideText(slide, '.nosto-slide-heading', slide_data['heading'], textColor, slide_data.heading_weight);
    custom.renderSlideText(slide, '.nosto-slide-description', slide_data['description'], textColor);

  },
  fetchPositionClass: function (position) {
    let positionPush = [];
    switch (position) {
      case "Top Left":
        positionPush.push("sm:place-self-start");
        positionPush.push("sm:text-start");
        break;
      case "Top Center":
        positionPush.push("sm:place-self-start-center");
        positionPush.push("sm:text-center");
        break;
      case "Top Right":
        positionPush.push("sm:place-self-start-end");
        positionPush.push("sm:text-end");
        break;
      case "Middle Left":
        positionPush.push("sm:place-self-center-start");
        positionPush.push("sm:text-start");
        break;
      case "Middle Center":
        positionPush.push("sm:place-self-center");
        positionPush.push("sm:text-center");
        break;
      case "Middle Right":
        positionPush.push("sm:place-self-center-end");
        positionPush.push("sm:text-end");
        break;
      case "Bottom Left":
        positionPush.push("sm:place-self-end-start");
        positionPush.push("sm:text-start");
        break;
      case "Bottom Center":
        positionPush.push("sm:place-self-end-center");
        positionPush.push("sm:text-center");
        break;
      case "Bottom Right":
        positionPush.push("sm:place-self-end");
        positionPush.push("sm:text-end");
        break;
    }
    return positionPush;
  },
  updateExpiration: function () {
    let selectedAnnouncement = document.querySelector(".prose.heading.is-selected");
    const countdownTimer = document.querySelector('countdown-timer');

    if (!countdownTimer) {
      return;
    }

    const expirationDate = selectedAnnouncement?.getAttribute('expiration-date');
    const expirationBehavior = selectedAnnouncement?.getAttribute('expiration-behavior');
    // Hide countdown if no expiration date or empty
    if (!expirationDate || expirationDate.trim() === '') {
      countdownTimer.style.display = 'none';
      return;
    }

    // If expiration date is in the past, hide countdown
    const now = new Date();
    const expDate = new Date(expirationDate);
    if (expDate < now) {
      countdownTimer.style.display = 'none';
      return;
    }
    // Show and update countdown if expiration date exists
    countdownTimer.style.display = '';
    // Only append time if not already present in the date string
    const newExpirationDate = expirationDate.includes('T') ? expirationDate : expirationDate + 'T23:59:59';

    // Store parent and next sibling for reinsertion
    const parent = countdownTimer.parentNode;
    const nextSibling = countdownTimer.nextSibling;

    // Remove from DOM to trigger cleanup
    parent.removeChild(countdownTimer);

    // Update the expires-at attribute
    countdownTimer.setAttribute('expires-at', newExpirationDate);
    countdownTimer.setAttribute('expiration-behavior', expirationBehavior || 'hide');
    // Re-insert to trigger connectedCallback and reset timer
    if (nextSibling) {
      parent.insertBefore(countdownTimer, nextSibling);
    } else {
      parent.appendChild(countdownTimer);
    }
  },
  handleButtons: function (button_values, button) {
    if (!button) {
      return;
    }
    if (!button_values) {
      button.style.display = 'none';
      return;
    }
    if (button_values.background) {
      button.style = "";

      if (button_values.style == 'Outline Button') {
        button.style.border = `solid 1px ${button_values.background}`;
      } else if (button_values.style == 'Solid Button') {
        button.style.background = button_values.background;
        button.style.border = `solid 1px ${button_values.background}`;
      } else {
        button.style.background = 'transparent';
        button.style.border = 'none';

      }



    }
    if (button_values.foreground) {
      button.style.color = button_values.foreground;
    }
    let buttonText = button_values['text'];
    let buttonurl = custom.checkForLocale(button_values['link']);
    if (buttonurl != "") {
      button.setAttribute("href", buttonurl);
    }
    button.textContent = buttonText;
    if (!buttonText || buttonText == '') {
      button.style.display = 'none';
    }
  },
  renderImage: function (collectionSectionid, selector, imageSrc) {
    if (!imageSrc || !document.getElementById(collectionSectionid) || !selector) {
      return; //If no image source is provided, do not proceed
    }
    let imageElem = document.getElementById(collectionSectionid).querySelector(selector);

    if (!imageElem) {
      return; // If no matching element is found, do not proceed
    }
    if (imageSrc) {
      imageElem.setAttribute(
        "src",
        imageSrc
      );
      imageElem.setAttribute(
        "srcset",
        imageSrc
      );
    }
  },
  renderSlideImage: function (slideshowImageElem, slide, is_mobile) {
    let imageSrc;

    if (slide) {
      if (is_mobile) {
        imageSrc = slide['image_mobile'];
      } else {
        imageSrc = slide['image_desktop'];
      }
    }
    if (slideshowImageElem && imageSrc) {
      slideshowImageElem.setAttribute(
        "src",
        imageSrc
      );
      slideshowImageElem.setAttribute(
        "srcset",
        imageSrc
      );
    }
  },
  renderSlideText: function (slide, selector, txt, color, weight) {
    if (slide.querySelectorAll(selector)) {
      slide.querySelectorAll(selector).forEach((elem) => {
        elem.innerHTML = txt;
        elem.style.color = color;
        if (weight) {
          elem.style.fontWeight = weight;
        }
      });
    }
  },
  callNostoProducts: function (
    doCarousel,
    placementId,
    productId,
    sectionId,
    productLimit,
    languageCode,
    discountPlacement
  ) {

    setTimeout(() => {
      custom.validateNostoSection(sectionId, doCarousel);
    }, 2000);

    setTimeout(() => {
      let section = document.getElementById("shopify-section-" + sectionId);
      if (section) {
        let productList = section.querySelector(`product-list`);
        let searchProducts = section.querySelector('.predictive-search__products');
        if (!productList && searchProducts) {
          productList = searchProducts;
        }
        if (!productList) {
          section.style.display = 'none';
        } else {
          let productCard = productList.querySelector(`product-card`);
          let productCardClass = productList.querySelector(`.product-card`);
          let horizontalCard = productList.querySelector(`.horizontal-product-card`);
          if (!productCard && !horizontalCard && !productCardClass) {
            section.style.display = 'none';
          }
        }
      }
    }, 10000);

    if (custom.getAttribute('from_key') == 'true') {
      custom.isCategoryPage = false;
      custom.isSearchPage = true;
    }
    if (custom.isProductPage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Product'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewProduct(productId)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isCategoryPage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Collection Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewCategory(this.currCollectionId)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {

              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isSearchPage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Search Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewSearch(searchTerm)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {

              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isHomePage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Front Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {

              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isCartPage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Cart Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewCart()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {

              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Front Page - Else Condition'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {

              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    }
  },
  linkToKeywordSearch: function (url) {
    if (!custom.getAttribute("debug_tracking")) {
      location.href = url;
    }
  },
  validateNostoSection: function (sectionId, doCarousel) {
    //If Nosto hasent set the slider products, hide the slider
    let section = document.getElementById("shopify-section-" + sectionId);
    if (!section) {
      return false;
    }
    let productList = section.querySelector(`product-list`);
    if (!productList) {
      return false;
    }
    let products = productList.querySelectorAll('product-card');
    let productsHorizonal = productList.querySelectorAll('.horizontal-product-card');

    if (!products && !productsHorizonal) {
      return false;
    }
    if (custom.getAttribute("debugrec")) {
      console.log("Number of products", products);
    }

    let prevNextButton = section.querySelector('.prev-next-button');
    if (prevNextButton) {
      section.querySelector('.prev-next-button').disabled = false;
    }
    return true;
  },
  handleCartRecDots: function (numberOfProducts) {
    if (numberOfProducts < 5) {
      let cartDots = document.querySelectorAll('.cart-carousel-dots');
      if (cartDots) {
        cartDots.forEach((dot, idx) => {
          if ((idx + 1) > numberOfProducts) {
            dot.style.display = 'none';
          }
        });
      }
    }
  },
  handleNostoProductResponse: function (
    placementId,
    sectionId,
    max_products,
    doCarousel,
    languageCode,
    discountPlacement,
    response
  ) {
    if (custom.getAttribute('debugrec')) {
      console.log('handleNostoProductResponse ←', {
        placementId,
        sectionId,
        placementPresent: response.recommendations.hasOwnProperty(placementId),
        availablePlacements: Object.keys(response.recommendations || {}),
        products: (response.recommendations[placementId]?.products || []).map(function (p) {
          return {
            name: p.name,
            handle: p.url ? p.url.split('/').pop() : '',
            price: p.price,
            url: p.url,
            thumbUrl: p.thumbUrl || p.thumb_url || null
          };
        })
      });
    }
    if (response.recommendations.hasOwnProperty(placementId)) {
      let section = document.getElementById("shopify-section-" + sectionId);

      if (!section) {
        console.log('No section found for id: shopify-section-' + sectionId);
        return;
      }
      let nosto_placement = response.recommendations[placementId];
      let recProducts = nosto_placement && nosto_placement.products ? nosto_placement.products : [];
      if (recProducts.length === 0) {
        // Empty placement — hide the shell, but never hide a section that
        // already has rendered products (a later cart-context response can be
        // empty even though the section is validly populated).
        if (!section.querySelector('.horizontal-product-card, product-card, .product-card')) {
          section.style.display = 'none';
        }
        return;
      }
      if (nosto_placement) {
        let nostoArr = nosto_placement.products;
        let slotId = nosto_placement.params ? nosto_placement.params.nosto : '';
        let title = nosto_placement.title;
        let doPdpCall = true;
        let nostoArray = nostoArr.slice(0, max_products);
        let index = 0;
        // Keep the section hidden until every product has been appended, then
        // reveal it in one go so it never flashes a partially-loaded state.
        let appendedCount = 0;
        let revealWhenDone = function () {
          appendedCount++;
          if (appendedCount >= nostoArray.length) {
            let sectionNow = document.getElementById('shopify-section-' + sectionId);
            if (sectionNow) {
              sectionNow.style.display = '';
            }
          }
        };
        nostoArray.map((product, idx) => {
          let productUrlSplit = product.url.split("/");

          let handleFiltered = productUrlSplit[productUrlSplit.length - 1];
          if (handleFiltered) {
            let section = document.getElementById('shopify-section-' + sectionId);
            let prose = section.querySelector('.prose');
            if (section) {
              if (title) {
                if (prose) {
                  section.querySelector('.prose').querySelector('.h2').innerHTML = title;
                }
              }
              if (prose) {
                section.querySelector('.prose').querySelector('.h2').style.display = '';
              }
              let productListElem = section.querySelector('product-list');
              if (!productListElem) {
                productListElem = section.querySelector('.predictive-search__products');
              }
              if (productListElem) {
                let sideCartElem = productListElem.querySelector('.side-cart-scroll');
                let scrollCarouselElem = productListElem.querySelector('scroll-carousel');
                if (sideCartElem) {
                  doPdpCall = false;
                  setTimeout(() => {
                    // Skip if this product is already in the list — the drawer
                    // re-render relaunch and trackNostoCart can both refill it.
                    if (sideCartElem.querySelector('.product-' + sectionId + '-' + handleFiltered + ', [handle="' + handleFiltered + '"]')) {
                      revealWhenDone();
                      return;
                    }
                    sideCartElem.innerHTML += custom.prefetchProduct(sectionId + '-' + handleFiltered, product, true);
                    custom.getPdpItem(handleFiltered, false, sectionId, false, slotId);
                    revealWhenDone();
                  }, custom.TIMEOUT_DELAY_MS);
                } else if (scrollCarouselElem) {
                  doPdpCall = false;
                  setTimeout(() => {
                    let prefetchData = custom.prefetchProduct(sectionId + '-' + handleFiltered, product, false);
                    scrollCarouselElem.innerHTML += prefetchData;
                    revealWhenDone();
                    setTimeout(() => {
                      custom.getPdpItem(handleFiltered, false, sectionId, false, slotId, false, '.product-' + sectionId + '-' + handleFiltered);
                    }, custom.TIMEOUT_DELAY_MS);
                  }, 500);
                } else {
                  doPdpCall = false;
                  setTimeout(() => {
                    productListElem.innerHTML += custom.prefetchProduct(sectionId + '-' + handleFiltered, product, false);
                    custom.getPdpItem(handleFiltered, false, sectionId, false, slotId);
                    revealWhenDone();
                  }, custom.TIMEOUT_DELAY_MS);
                }
              } else {
                revealWhenDone();
              }
            }

            if (document.getElementById('shopify-section-side-cart')) {
              const sideCartHeading = document.getElementById('shopify-section-side-cart').querySelector('.sidecart-heading');
              if (sideCartHeading) {
                sideCartHeading.innerHTML = title;
                if (custom.getAttribute('debugrec')) {
                  console.log('Side Cart Heading:' + title, sideCartHeading);
                }
              }
            }
            if (doPdpCall) {
              custom.getPdpItem(handleFiltered, false, sectionId, false, slotId);
            }

          } else {
            // No handle for this product — still count it so the reveal fires.
            revealWhenDone();
          }
        });
        let numberOfProducts = nostoArray.length;
        custom.handleCartRecDots(numberOfProducts);
      }
    } else {
      // Placement missing from the response entirely — hide the empty shell,
      // but never hide a section that already has rendered products (a later
      // cart-context response can be empty for a populated section).
      let section = document.getElementById("shopify-section-" + sectionId);
      if (section && !section.querySelector('.horizontal-product-card, product-card, .product-card')) {
        section.style.display = 'none';
      }
      custom.validateNostoSection(sectionId, doCarousel);
    }
  },
  /* ---------------   * Nosto Search ------------ */
  loadSearchRecommendations: function (placementId) {
    let searchProductId = "";
    if (typeof productId !== "undefined") {
      searchProductId = productId.toString();
    }
    custom.callNostoProducts(false, placementId, searchProductId, 'search-bar', 4, theme.settings.lang);
  },
  searchIconClicked: function () {
    if (!custom.searchClicked) {
      custom.loadSearchRecommendations(theme.settings.nosto_search_placement_id);
    }
    custom.searchClicked = true;
  },
  filterNostoSearch: function (searchTerm, resultsDivClass, sort, limit, use_default) {
    let resultsDiv = document.getElementById('keyword-results');
    let searchPage = window.location.href.indexOf("/search") != -1;

    let field = "price";
    if (sort == "newest") {
      sort = "desc";
      field = "datePublished";
    }
    let defaultKey = "use-default-account-id-search";
    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
        localStorage.setItem(defaultKey, Date.now());
      }
    }
    let defaultTs = parseInt(localStorage.getItem(defaultKey));
    if (defaultTs && (Date.now() - defaultTs) < 300000) {
      accountId = theme.settings.defaultNostoId;
    } else if (defaultTs) {
      localStorage.removeItem(defaultKey);
      custom.currAccountId = null;
    }
    if (!custom.searchPage) {
      limit = 4;
    }
    if (!limit) {
      limit = 140;
    }

    let query = `query ($query: String) {
        search (
          accountId: "${accountId}", 
          products: {
            size: ${limit}
          }
          query: $query
        ) {
          keywords {
            hits {
              keyword
            }
          }
          redirect
          products {
            hits {
              name
              thumbUrl
              price
              listPrice
              productId
              url
            }
            total
          }
        }
      }`;
    if (sort && sort != "") {
      query = `query ($query: String) {
        search (
          accountId: "${accountId}", 
          query: $query,
          products: {
            sort: [{field: "${field}", order: ${sort}}]
          }) {
          keywords {
            hits {
              keyword
            }
          }
          products {
            hits {
              name
              thumbUrl
              price
              listPrice
              productId
              url
            }
            total
          }
        }
      }`;
    }

    if (!resultsDiv) {
      return;
    }

    resultsDiv.innerHTML = `
      <div class="v-stack gap-6 sm:gap-8">
        <p class="predictive-search__category h6 text-subdued">Suggestions</p>
        <div class="predictive-search__suggestions scroll-area bleed md:unbleed" id="nostoKeywords"></div>
      </div>
    `;

    if (custom.getAttribute("debugrec")) {
      console.log("graphql search request", query);
    }
    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
        variables: {
          query: searchTerm,
        },
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let errors = result.errors;
        let hasError = false;

        if (errors && errors.length > 0) {
          hasError = true;
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
        }
        if (hasError) {
          if (!use_default) {
            custom.filterNostoSearch(searchTerm, resultsDiv, sort, limit, true);
          }
        } else if (result) {
          if (custom.getAttribute("debugrec")) {
            console.log("graphql search response", result);
          }
          if (custom.getAttribute('q') && !custom.getAttribute("from_key")) {
            let redirect = result.data.search.redirect;
            if (redirect) {
              location.href = redirect;
            } else {
              custom.trackNostoSearchSubmit(searchTerm);
            }

          }

          if (custom.getAttribute("from_key") == 'true') {
            let option = {};
            option.isKeyword = true;
            custom.trackNostoSearch("autocomplete", query, result.data.search, option, searchTerm);
          }
          else if (custom.getAttribute('q')) {
            custom.trackNostoSearch("serp", query, result.data.search, null, searchTerm);
          } else {//Non search page
            custom.trackNostoSearch("autocomplete", query, result.data.search, null, searchTerm);
          }
          custom.currAccountId = accountId;
          let hits = result.data.search.products.hits;
          let keywords_nosto = "";
          if (result.data.search.keywords) {
            keywords_nosto = result.data.search.keywords.hits;
          }
          let searchResults = "";


          let nostoKeywordsElem = document.getElementById("nostoKeywords");
          if (nostoKeywordsElem && keywords_nosto && keywords_nosto.length > 0) {
            nostoKeywordsElem.innerHTML = "";
            keywords_nosto.map((item) => {
              let keyword = item.keyword;
              let locale = "";
              if (theme.settings.locale && theme.settings.locale != custom.default_lang) {
                custom.updateLocale();
                locale = '/' + theme.settings.locale
              }
              nostoKeywordsElem.innerHTML += `
              <div>
                <a onclick="custom.linkToKeywordSearch('${locale}/search?q=${keyword}&from_key=true');" href="#" class="link-reverse" data-instant=""><span>${keyword}</span></a>
              </div>`;
            });
          }

          searchResults = document.getElementById("search-results");
          searchResults.innerHTML = "";

          if (hits.length == 0) {
            notFound = document.getElementById("notFound");
            if (notFound) {
              notFound.classList.add("show");
            }

          }
          else {
            hits.map((product) => {
              let productUrl = product.url;
              productArr = productUrl.split("/");
              let productHandle = productArr[productArr.length - 1];
              let nostoSearchElem = document.getElementById("nostoSearch");
              if (nostoSearchElem && searchPage) {
                if (productHandle) {
                  nostoSearchElem.innerHTML += custom.prefetchProduct(
                    productHandle,
                    product
                  );
                  custom.getPdpItem(productHandle, undefined, undefined, undefined, slotId, undefined, undefined, isGallery);
                }
              } else {
                if (productHandle) {
                  searchResults.innerHTML += `<div class="product-${productHandle}"></div>`;
                  custom.getPdpItem(productHandle, true);
                }
              }
            });
          }
        }
      });
  },
  trackNostoSearchSubmit: function (searchTerm) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearchSubmit: ', 'apicall': 'api.recordSearchSubmit', 'searchTerm': searchTerm });
    }
    nostojs(api => {
      const query = searchTerm
      api.recordSearchSubmit(query)
    })
  },
  /**
 * Logs an error to Datadog.
 *
 * @param {string} error - A Javascript error object.
 * @param {Object} [additionalAttributes] - An optional Javascript object containing extra data in the log.
 * @example
 * const error = new Error("Datadog Error Example");
 * const additionalAttributes = {"key1": "value1", "key2": "value2"};
 * custom.logErrorToDatadog(error, additionalAttributes);
 */
  logErrorToDatadog: function (error, additionalAttributes) {
    custom.waitForScriptAndVariable('https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js', 'DD_RUM', (lib) => {
      window.DD_RUM.onReady(function () {
        window.DD_RUM.addError(error, additionalAttributes);
      });
    });
  },
  waitForScriptAndVariable: function (scriptSrc, variableName, callback) {

    const script = document.querySelector(`script[src*="${scriptSrc}"]`);

    if (script) {
      script.addEventListener('load', () => {
        // Script loaded, now wait for variable
        custom.waitForVariable(variableName, callback);
      });
    } else {
      // Script not found, fall back to polling
      custom.waitForVariable(variableName, callback);
    }
  },
  waitForVariable: function (variableName, callback, timeout = 10000) {
    const startTime = Date.now();

    const checkVariable = setInterval(() => {
      if (window[variableName] !== undefined) {
        clearInterval(checkVariable);
        callback(window[variableName]);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(checkVariable);
        console.warn(`Variable wait timeout: ${variableName} not found within ${timeout}ms`);
      }
    }, 100);
  },
  logIfNavigationIsEmpty: function (navJson) {
    if (navJson == null || !navJson.nav_categories || navJson.nav_categories.length == 0) {
      const error = new Error("Navigation is Empty");
      error.dd_fingerprint = "navigation-is-empty";
      var navData = navJson
      if (navJson == null) {
        navData = "null";
      } else if (Object.keys(navJson).length === 0) {
        navData = "empty";
      }
      console.log("Nav Error: About to log to Datadog");
      const additionalAttributes = { "navigationData": navData };
      custom.logErrorToDatadog(error, additionalAttributes);
    }
  },
};

custom.updateBreadCrumbs();

function loopClassDisplay(whichClass, cssDisplay) {
  const elements = document.querySelectorAll(whichClass);
  elements.forEach((element) => {
    element.style.display = cssDisplay;
  });
}

async function fetchCartItems() {

  this.loopClassDisplay(".loading-overlay", "none");
  try {
    // Get cart drawer section ID for bundled section rendering
    var cartDrawer = document.querySelector("cart-drawer");
    var sectionId = cartDrawer
      ? (cartDrawer.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '')
         || cartDrawer.getAttribute('data-section-id'))
      : null;

    // GET cart.js does not support bundled section rendering (POST-only),
    // so fetch the cart and the section HTML in parallel via the Section Rendering API
    const cartPromise = fetch(`${Shopify.routes.root}cart.js`, { cache: "no-store" });
    const sectionsPromise = sectionId
      ? fetch(`${window.location.pathname}?sections=${sectionId}`, { cache: "no-store" })
      : null;

    const response = await cartPromise;
    if (!response.ok) {
      throw new Error("Something wrongs");
    }
    const cart = await response.json();

    if (sectionsPromise) {
      const sectionsResponse = await sectionsPromise;
      if (sectionsResponse.ok) {
        cart.sections = await sectionsResponse.json();
      }
    }

    let thbElem = document.querySelector(".thb-item-count");
    if (thbElem) {
      thbElem.textContent = cart.item_count;
    }

    // Remove loading state and dispatch cart:change with sections
    if (cartDrawer) cartDrawer.classList.remove("is-loading");

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'variant:add',
        cart: cart,
        onSuccessDo: 'force_open_drawer'
      }
    }));

    return cart;
  } catch (error) {
    console.error("Fetch error:", error);
    var cd = document.querySelector("cart-drawer");
    if (cd) cd.classList.remove("is-loading");
  }

}

async function getCartItems() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    return cart;
  } catch (error) {
    console.error('Error fetching cart:', error);
    return null;
  }
}

window.addEventListener('scroll', function () {
  custom.checkForStoredContentViews();
});
setTimeout(() => {
  custom.checkForStoredContentViews();
}, 500);

function applyValueToDropdown(position) {
  const iframe = document.getElementById('klaviyo-bis-iframe');
  const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
  iframe.addEventListener('load', () => {
    try {
      const select = iframeDocument.querySelector('select#variants');
      if (position >= 0 && position < select.options.length) {
        select.selectedIndex = position;
      } else {
        console.error('Invalid position number.');
      }
    } catch (error) {
      console.error('Error accessing iframe content:', error);
    }
  });
}

function sanitizeAndConvertToJson(inputStr) {
  try {
    const input = JSON.parse(inputStr.replace(/(\w+):/g, '"$1":'));

    const formattedInput = input.map(obj => {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          let formattedKey = /^\w+$/.test(key) ? key : `"${key}"`;
          let formattedValue = Array.isArray(value)
            ? value.map(v => (typeof v === 'number' || !isNaN(v) ? v.toString() : v))
            : value;
          return [formattedKey, formattedValue];
        })
      );
    });
    return JSON.stringify(formattedInput, null, 2);
  } catch (error) {
    console.error("Invalid JSON input", error);
    return null;
  }
}

window.addEventListener('click', (event) => {
  if (event.target.classList.contains('klaviyo-bis-trigger')) {
    const closestDataSet = event.target.closest('[count]');
    const linkValue = closestDataSet.getAttribute('count');
    if (linkValue) {
      applyValueToDropdown(linkValue);
    } else {
      console.error('Klaviyo trigger does not exist')
    }
  }
});

// Match promotion tile height to adjacent product cards
function adjustPromotionTileHeight() {
  const promotionTiles = document.querySelectorAll('.promotion-column[class*="promotion-column-width--"]');

  promotionTiles.forEach(tile => {
    // Find the next sibling that's a product-card element
    let nextElement = tile.nextElementSibling;
    while (nextElement && nextElement.tagName !== 'PRODUCT-CARD') {
      nextElement = nextElement.nextElementSibling;
    }

    if (nextElement) {
      // Get the height of the entire product card (not just the image)
      const productHeight = nextElement.offsetHeight;

      if (productHeight > 0) {
        // Check if this is a tile that spans 2 rows (1x2 or 2x2)
        const isTwoRowsHeight = tile.classList.contains('promotion-column-width--1x2') ||
          tile.classList.contains('promotion-column-width--2x2');

        let tileHeight;
        if (isTwoRowsHeight) {
          // For tiles spanning 2 rows, double the height plus any gap
          tileHeight = (productHeight * 2) + 'px';
        } else {
          // For single row tiles, match the product height
          tileHeight = productHeight + 'px';
        }

        tile.style.height = tileHeight;

        const img = tile.querySelector('img');
        if (img) {
          img.style.height = tileHeight;
        }
      }
    }
  });
}

// Run on load and after images load - 
document.addEventListener('DOMContentLoaded', adjustPromotionTileHeight);
window.addEventListener('load', adjustPromotionTileHeight);
window.addEventListener('resize', adjustPromotionTileHeight);

// Initialize announcement bar carousel countdown timer sync
document.addEventListener('DOMContentLoaded', function () {
  const announcementCarousel = document.querySelector('announcement-bar-carousel');
  if (announcementCarousel) {
    // Listen for carousel settle event (fires after slide change animation completes)
    announcementCarousel.addEventListener('carousel:settle', function (event) {
      // Small delay to ensure is-selected class has been updated
      setTimeout(() => {
        custom.updateExpiration();
      }, 50);
    });
  }
});

function stringToHTML(str) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');
  return doc.body.firstChild;
}

function convertToLettersAndNumbers(str) {
  return str.replace(/[^a-zA-Z0-9\u00C0-\u024F\u3000-\u9FFF]/g, '');
}

function isMobileUserAgent() {
  const mobileRegex = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i;
  return mobileRegex.test(navigator.userAgent);
}

(function () {
  const originalFetch = window.fetch;
  window.fetch = async function (resource, config) {
    try {
      const response = await originalFetch(resource, config);
      if (typeof resource === "string" && (resource.includes("/cart/add") || resource.includes("/cart/change"))) {
        try {
          response.clone().json().then((data) => {
            // Use the response data directly instead of fetching /cart.js again
            if (resource.includes("/cart/add")) {
              // For add, we need full cart - but use a debounced single fetch
              if (!window.__cartNostoTimeout) {
                window.__cartNostoTimeout = setTimeout(() => {
                  window.__cartNostoTimeout = null;
                  originalFetch('/cart.js').then(r => r.json()).then((cart) => {
                    if (!cart || !cart.items) return;
                    let cartItems = cart.items.map((item) => ({
                      name: item.title,
                      price_currency_code: Shopify.currency.active,
                      product_id: String(item.product_id),
                      quantity: item.quantity,
                      sku_id: item.sku,
                      unit_price: item.price
                    }));
                    custom.trackNostoCart(cartItems);
                  });
                }, 500);
              }
            } else if (resource.includes("/cart/change")) {
              originalFetch('/cart.js').then(r => r.json()).then((cart) => {
                if (!cart || !cart.items) return;
                let cartItems = cart.items.map((item) => ({
                  name: item.title,
                  price_currency_code: Shopify.currency.active,
                  product_id: String(item.product_id),
                  quantity: item.quantity,
                  sku_id: item.sku,
                  unit_price: item.price
                }));
                custom.trackNostoCart(cartItems);
              });
            }
          });
        } catch (err) {
          console.warn("⚠️ Fetch patch error:", err);
        }
      }

      return response;
    } catch (error) {
      // Silently catch SSL errors for localhost development URLs
      const url = typeof resource === "string" ? resource : resource.url;
      if (url && (url.includes("127.0.0.1") || url.includes("localhost"))) {
        // Return a minimal failed response for localhost SSL errors
        return Promise.reject(error);
      }
      // Re-throw other errors
      throw error;
    }
  };
})();

/**
 * Product Card Swatch Display Mode Handler
 * Supports: all, first (expand), quick (quick view)
 * Uses event delegation for reliability
 */
(function() {
  function checkSwatchOverflow() {
    document.querySelectorAll('.product-card__swatches--collapsible').forEach(function(container) {
      if (container.classList.contains('is-expanded')) return;
      var fieldset = container.querySelector('.product-card__swatches-fieldset');
      if (fieldset && fieldset.scrollHeight > fieldset.clientHeight + 2) {
        container.classList.add('has-overflow');
      } else {
        container.classList.remove('has-overflow');
      }
    });
  }

  var resizeTimer;
  function debouncedCheck() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkSwatchOverflow, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkSwatchOverflow);
  } else {
    checkSwatchOverflow();
  }
  window.addEventListener('resize', debouncedCheck);
  window.checkSwatchOverflow = checkSwatchOverflow;

  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { checkSwatchOverflow(); return; }
    }
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  document.addEventListener('click', function(e) {
    const toggleBtn = e.target.closest('.product-card__swatches-toggle');
    if (!toggleBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const container = toggleBtn.closest('.product-card__swatches');
    if (!container) return;

    const mode = container.dataset.swatchDisplayMode;

    if (mode === 'quick') {
      // Quick view mode: open quick buy modal
      const quickBuyId = container.dataset.quickBuyId;
      if (quickBuyId) {
        const modal = document.getElementById(quickBuyId);
        if (modal && typeof modal.show === 'function') {
          modal.show();
        }
      }
    } else {
      // Default/first mode: expand/collapse the swatch list
      const isExpanded = container.classList.toggle('is-expanded');
      toggleBtn.setAttribute('aria-expanded', isExpanded);
    }
  });
})();

// Bulk order trigger — clicks on .bulk-order-trigger proxy to the app's CSV upload button
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('.bulk-order-trigger');
  if (!trigger) return;
  e.preventDefault();
  var appButton = document.querySelector('#mrca-div-embedded-sf-csvupload button');
  if (appButton) appButton.click();
});

// GRIT-6029: cart item delete visual feedback — removing an item takes a few
// seconds (cart/change round-trip + re-render/reload) with no indication that
// anything is happening. Flag the line item as removing the instant the remove
// link is clicked so the spinner overlay (custom.css) appears immediately.
// Capturing phase so it runs regardless of which handler (theme.js drawer
// handler or the GRIT-6018 cart-page queue) processes the click.
document.addEventListener('click', function(e) {
  var anchor = e.target.closest && e.target.closest('a[href*="/cart/change"]');
  if (!anchor) return;
  var qty;
  try {
    qty = new URL(anchor.href).searchParams.get('quantity');
  } catch (err) {
    return;
  }
  // Only clicks that remove the line entirely (quantity=0) — covers both the
  // Remove link and a minus anchor stepping the quantity down to zero.
  if (qty !== '0') return;
  var lineItem = anchor.closest('line-item');
  var row = anchor.closest('tr');
  // Desktop cart page: the Remove link sits in its own table cell outside
  // <line-item> (sections/main-cart.liquid), so closest('line-item') misses.
  // Fall back to the order-summary row and flag its line-item for the spinner.
  if (!lineItem && row) lineItem = row.querySelector('line-item');
  [lineItem, row].forEach(function(el) {
    if (el) {
      el.classList.add('is-removing');
      el.setAttribute('aria-busy', 'true');
    }
  });
}, true);
